const topRatedMovies = [
	{
		rank: 1,
		movie_name: "The Shawshank Redemption",
		movie_year: "1994",
		genre: ["Drama"],
		director_name: "Frank Darabont",
		rating: "9.3",
		actors_list: [
			"Tim Robbins",
			"Morgan Freeman",
			"Bob Gunton",
			"William Sadler",
			"Clancy Brown",
			"Gil Bellows",
			"Mark Rolston",
			"James Whitmore",
			"Jeffrey DeMunn",
			"Larry Brandenburg",
			"Neil Giuntoli",
			"Brian Libby",
			"David Proval",
			"Joseph Ragno",
			"Jude Ciccolella",
			"Paul McCrane",
			"Renee Blaine",
			"Scott Mann",
		],
		trailer: "https://www.youtube.com/watch?v=PLl99DlL6b4",
		id: "tt0111161",
		description:
			"Imprisoned in the 1940s for the double murder of his wife and her lover, upstanding banker Andy Dufresne begins a new life at the Shawshank prison, where he puts his accounting skills to work for an amoral warden. During his long stretch in prison, Dufresne comes to be admired by the other inmates -- including an older prisoner named Red -- for his integrity and unquenchable sense of hope.",
	},
	{
		rank: 2,
		movie_name: "The Godfather",
		movie_year: "1972",
		genre: ["Crime", "Drama"],
		director_name: "Francis Ford Coppola",
		rating: "9.2",
		actors_list: [
			"Marlon Brando",
			"Al Pacino",
			"James Caan",
			"Diane Keaton",
			"Richard S. Castellano",
			"Robert Duvall",
			"Sterling Hayden",
			"John Marley",
			"Richard Conte",
			"Al Lettieri",
			"Abe Vigoda",
			"Talia Shire",
			"Gianni Russo",
			"John Cazale",
			"Rudy Bond",
			"Al Martino",
			"Morgana King",
			"Lenny Montana",
		],
		trailer: "https://www.youtube.com/watch?v=UaVTIH8mujA",
		id: "tt0068646",
		description:
			"Spanning the years 1945 to 1955, a chronicle of the fictional Italian-American Corleone crime family. When organized crime family patriarch, Vito Corleone barely survives an attempt on his life, his youngest son, Michael steps in to take care of the would-be killers, launching a campaign of bloody revenge.",
	},
	{
		rank: 3,
		movie_name: "The Dark Knight",
		movie_year: "2008",
		genre: ["Action", "Crime", "Drama"],
		director_name: "Christopher Nolan",
		rating: "9.0",
		actors_list: [
			"Christian Bale",
			"Heath Ledger",
			"Aaron Eckhart",
			"Michael Caine",
			"Maggie Gyllenhaal",
			"Gary Oldman",
			"Morgan Freeman",
			"Monique Gabriela Curnen",
			"Ron Dean",
			"Cillian Murphy",
			"Chin Han",
			"Nestor Carbonell",
			"Eric Roberts",
			"Ritchie Coster",
			"Anthony Michael Hall",
			"Keith Szarabajka",
			"Colin McFarlane",
			"Joshua Harto",
		],
		trailer: "https://www.youtube.com/watch?v=_PZpmTj1Q8Q&t=13s",
		id: "tt0468569",
		description:
			"Batman raises the stakes in his war on crime. With the help of Lt. Jim Gordon and District Attorney Harvey Dent, Batman sets out to dismantle the remaining criminal organizations that plague the streets. The partnership proves to be effective, but they soon find themselves prey to a reign of chaos unleashed by a rising criminal mastermind known to the terrified citizens of Gotham as the Joker.",
	},
	{
		rank: 4,
		movie_name: "The Godfather: Part II",
		movie_year: "1974",
		genre: ["Crime", "Drama"],
		director_name: "Francis Ford Coppola",
		rating: "9.0",
		actors_list: [
			"Al Pacino",
			"Robert De Niro",
			"Robert Duvall",
			"Diane Keaton",
			"John Cazale",
			"Talia Shire",
			"Lee Strasberg",
			"Michael V. Gazzo",
			"G.D. Spradlin",
			"Richard Bright",
			"Gastone Moschin",
			"Tom Rosqui",
			"Bruno Kirby",
			"Frank Sivero",
			"Francesca De Sapio",
			"Morgana King",
			"Marianna Hill",
			"Leopoldo Trieste",
		],
		trailer: "https://www.youtube.com/watch?v=9O1Iy9od7-A",
		id: "tt0071562",
		description:
			"In the continuing saga of the Corleone crime family, a young Vito Corleone grows up in Sicily and in 1910s New York. In the 1950s, Michael Corleone attempts to expand the family business into Las Vegas, Hollywood and Cuba.",
	},
	{
		rank: 5,
		movie_name: "12 Angry Men",
		movie_year: "1957",
		genre: ["Crime", "Drama"],
		director_name: "Sidney Lumet",
		rating: "9.0",
		actors_list: [
			"Henry Fonda",
			"Lee J. Cobb",
			"Martin Balsam",
			"John Fiedler",
			"E.G. Marshall",
			"Jack Klugman",
			"Edward Binns",
			"Jack Warden",
			"Joseph Sweeney",
			"Ed Begley",
			"George Voskovec",
			"Robert Webber",
			"Rudy Bond",
			"Tom Gorman",
			"James Kelly",
			"Billy Nelson",
			"John Savoca",
			"Walter Stocker",
		],
		trailer: "https://www.youtube.com/watch?v=TEN-2uTi2c0&t=2s",
		id: "tt0050083",
		description:
			"The defense and the prosecution have rested and the jury is filing into the jury room to decide if a young Spanish-American is guilty or innocent of murdering his father. What begins as an open and shut case soon becomes a mini-drama of each of the jurors' prejudices and preconceptions about the trial, the accused, and each other.",
	},
	{
		rank: 6,
		movie_name: "Schindler's List",
		movie_year: "1993",
		genre: ["Biography", "Drama", "History"],
		director_name: "Steven Spielberg",
		rating: "9.0",
		actors_list: [
			"Liam Neeson",
			"Ralph Fiennes",
			"Ben Kingsley",
			"Caroline Goodall",
			"Jonathan Sagall",
			"Embeth Davidtz",
			"Malgorzata Gebel",
			"Shmuel Levy",
			"Mark Ivanir",
			"Béatrice Macola",
			"Andrzej Seweryn",
			"Friedrich von Thun",
			"Krzysztof Luft",
			"Harry Nehring",
			"Norbert Weisser",
			"Adi Nitzan",
			"Michael Schneider",
			"Miri Fabian",
		],
		trailer: "https://www.youtube.com/watch?v=mxphAlJID9U",
		id: "tt0108052",
		description:
			"The true story of how businessman Oskar Schindler saved over a thousand Jewish lives from the Nazis while they worked as slaves in his factory during World War II.",
	},
	{
		rank: 7,
		movie_name: "The Lord of the Rings: The Return of the King",
		movie_year: "2003",
		genre: ["Action", "Adventure", "Drama"],
		director_name: "Peter Jackson",
		rating: "9.0",
		actors_list: [
			"Elijah Wood",
			"Viggo Mortensen",
			"Ian McKellen",
			"Orlando Bloom",
			"Noel Appleby",
			"Ali Astin",
			"Sean Astin",
			"David Aston",
			"John Bach",
			"Sean Bean",
			"Cate Blanchett",
			"Billy Boyd",
			"Sadwyn Brophy",
			"Alistair Browning",
			"Marton Csokas",
			"Richard Edge",
			"Jason Fitch",
			"Bernard Hill",
		],
		trailer: "https://www.youtube.com/watch?v=r5X-hFf6Bwo",
		id: "tt0167260",
		description:
			"Aragorn is revealed as the heir to the ancient kings as he, Gandalf and the other members of the broken fellowship struggle to save Gondor from Sauron's forces. Meanwhile, Frodo and Sam take the ring closer to the heart of Mordor, the dark lord's realm.",
	},
	{
		rank: 8,
		movie_name: "Pulp Fiction",
		movie_year: "1994",
		genre: ["Crime", "Drama"],
		director_name: "Quentin Tarantino",
		rating: "8.9",
		actors_list: [
			"John Travolta",
			"Uma Thurman",
			"Samuel L. Jackson",
			"Bruce Willis",
			"Tim Roth",
			"Amanda Plummer",
			"Laura Lovelace",
			"Phil LaMarr",
			"Frank Whaley",
			"Burr Steers",
			"Ving Rhames",
			"Paul Calderon",
			"Bronagh Gallagher",
			"Rosanna Arquette",
			"Eric Stoltz",
			"Jerome Patrick Hoban",
			"Michael Gilden",
			"Gary Shorelle",
		],
		trailer: "https://www.youtube.com/watch?v=tGpTpVyI_OQ",
		id: "tt0110912",
		description:
			"A burger-loving hit man, his philosophical partner, a drug-addled gangster's moll and a washed-up boxer converge in this sprawling, comedic crime caper. Their adventures unfurl in three stories that ingeniously trip back and forth in time.",
	},
	{
		rank: 9,
		movie_name: "The Lord of the Rings: The Fellowship of the Ring",
		movie_year: "2001",
		genre: ["Action", "Adventure", "Drama"],
		director_name: "Peter Jackson",
		rating: "8.8",
		actors_list: [
			"Elijah Wood",
			"Ian McKellen",
			"Orlando Bloom",
			"Sean Bean",
			"Alan Howard",
			"Noel Appleby",
			"Sean Astin",
			"Sala Baker",
			"Billy Boyd",
			"Andy Serkis",
			"Marton Csokas",
			"Viggo Mortensen",
			"Megan Edwards",
			"Michael Elsworth",
			"Cate Blanchett",
			"Mark Ferguson",
			"Ian Holm",
			"Christopher Lee",
		],
		trailer: "https://www.youtube.com/watch?v=V75dMMIW2B4",
		id: "tt0120737",
		description:
			"Young hobbit Frodo Baggins, after inheriting a mysterious ring from his uncle Bilbo, must leave his home in order to keep it from falling into the hands of its evil creator. Along the way, a fellowship is formed to protect the ringbearer and make sure that the ring arrives at its final destination: Mt. Doom, the only place where it can be destroyed.",
	},
	{
		rank: 10,
		movie_name: "The Good, the Bad and the Ugly",
		movie_year: "1966",
		genre: ["Adventure", "Western"],
		director_name: "Sergio Leone",
		rating: "8.8",
		actors_list: [
			"Clint Eastwood",
			"Eli Wallach",
			"Lee Van Cleef",
			"Aldo Giuffrè",
			"Luigi Pistilli",
			"Rada Rassimov",
			"Enzo Petito",
			"Claudio Scarchilli",
			"John Bartha",
			"Livio Lorenzon",
			"Antonio Casale",
			"Sandro Scarchilli",
			"Benito Stefanelli",
			"Angelo Novi",
			"Antonio Casas",
			"Aldo Sambrell",
			"Al Mulock",
			"Sergio Mendizábal",
		],
		trailer: "https://www.youtube.com/watch?v=WCN5JJY_wiA",
		id: "tt0060196",
		description:
			"While the Civil War rages on between the Union and the Confederacy, three men – a quiet loner, a ruthless hitman, and a Mexican bandit – comb the American Southwest in search of a strongbox containing $200,000 in stolen gold.",
	},
	{
		rank: 11,
		movie_name: "Forrest Gump",
		movie_year: "1994",
		genre: ["Drama", "Romance"],
		director_name: "Robert Zemeckis",
		rating: "8.8",
		actors_list: [
			"Tom Hanks",
			"Robin Wright",
			"Gary Sinise",
			"Sally Field",
			"Rebecca Williams",
			"Michael Conner Humphreys",
			"Harold G. Herthum",
			"George Kelly",
			"Bob Penny",
			"John Randall",
			"Sam Anderson",
			"Margo Moorer",
			"Ione M. Telech",
			"Christine Seabrook",
			"John Worsham",
			"Peter Dobson",
			"Siobhan Fallon Hogan",
			"Alexander Zemeckis",
		],
		trailer: "https://www.youtube.com/watch?v=bLvqoHBptjg",
		id: "tt0109830",
		description:
			"A man with a low IQ has accomplished great things in his life and been present during significant historic events—in each case, far exceeding what anyone imagined he could do. But despite all he has achieved, his one true love eludes him.",
	},
	{
		rank: 12,
		movie_name: "Fight Club",
		movie_year: "1999",
		genre: ["Drama"],
		director_name: "David Fincher",
		rating: "8.8",
		actors_list: [
			"Brad Pitt",
			"Edward Norton",
			"Meat Loaf",
			"Zach Grenier",
			"Richmond Arquette",
			"David Andrews",
			"George Maguire",
			"Eugenie Bondurant",
			"Christina Cabot",
			"Helena Bonham Carter",
			"Sydney 'Big Dawg' Colston",
			"Rachel Singer",
			"Christie Cronenweth",
			"Tim DeZarn",
			"Ezra Buzzington",
			"Dierdre Downing-Jackson",
			"Bob Stephenson",
			"Charlie Dell",
		],
		trailer: "https://www.youtube.com/watch?v=BdJKm16Co6M",
		id: "tt0137523",
		description:
			"A ticking-time-bomb insomniac and a slippery soap salesman channel primal male aggression into a shocking new form of therapy. Their concept catches on, with underground 'fight clubs' forming in every town, until an eccentric gets in the way and ignites an out-of-control spiral toward oblivion.",
	},
	{
		rank: 13,
		movie_name: "Inception",
		movie_year: "2010",
		genre: ["Action", "Adventure", "Sci-Fi"],
		director_name: "Christopher Nolan",
		rating: "8.8",
		actors_list: [
			"Leonardo DiCaprio",
			"Joseph Gordon-Levitt",
			"Elliot Page",
			"Ken Watanabe",
			"Tom Hardy",
			"Dileep Rao",
			"Cillian Murphy",
			"Tom Berenger",
			"Marion Cotillard",
			"Pete Postlethwaite",
			"Michael Caine",
			"Lukas Haas",
			"Tai-Li Lee",
			"Claire Geare",
			"Magnus Nolan",
			"Taylor Geare",
			"Johnathan Geare",
			"Tohoru Masamune",
		],
		trailer: "https://www.youtube.com/watch?v=YoHD9XEInc0",
		id: "tt1375666",
		description:
			"Cobb, a skilled thief who commits corporate espionage by infiltrating the subconscious of his targets is offered a chance to regain his old life as payment for a task considered to be impossible: 'inception', the implantation of another person's idea into a target's subconscious.",
	},
	{
		rank: 14,
		movie_name: "The Lord of the Rings: The Two Towers",
		movie_year: "2002",
		genre: ["Action", "Adventure", "Drama"],
		director_name: "Peter Jackson",
		rating: "8.8",
		actors_list: [
			"Elijah Wood",
			"Ian McKellen",
			"Viggo Mortensen",
			"Orlando Bloom",
			"Bruce Allpress",
			"Sean Astin",
			"John Bach",
			"Sala Baker",
			"Cate Blanchett",
			"Billy Boyd",
			"Jed Brophy",
			"Sam Comery",
			"Brad Dourif",
			"Calum Gittins",
			"Bernard Hill",
			"Bruce Hopkins",
			"Paris Howe Strewe",
			"Christopher Lee",
		],
		trailer: "https://www.youtube.com/watch?v=LbfMDwc4azU",
		id: "tt0167261",
		description:
			"Frodo Baggins and the other members of the Fellowship continue on their sacred quest to destroy the One Ring--but on separate paths. Their destinies lie at two towers--Orthanc Tower in Isengard, where the corrupt wizard Saruman awaits, and Sauron's fortress at Barad-dur, deep within the dark lands of Mordor. Frodo and Sam are trekking to Mordor to destroy the One Ring of Power while Gimli, Legolas and Aragorn search for the orc-captured Merry and Pippin. All along, nefarious wizard Saruman awaits the Fellowship members at the Orthanc Tower in Isengard.",
	},
	{
		rank: 15,
		movie_name: "Star Wars: Episode V - The Empire Strikes Back",
		movie_year: "1980",
		genre: ["Action", "Adventure", "Fantasy"],
		director_name: "Irvin Kershner",
		rating: "8.7",
		actors_list: [
			"Mark Hamill",
			"Harrison Ford",
			"Carrie Fisher",
			"Billy Dee Williams",
			"Anthony Daniels",
			"David Prowse",
			"Peter Mayhew",
			"Kenny Baker",
			"Frank Oz",
			"Alec Guinness",
			"Jeremy Bulloch",
			"John Hollis",
			"Jack Purvis",
			"Des Webb",
			"Clive Revill",
			"Kenneth Colley",
			"Julian Glover",
			"Michael Sheard",
		],
		trailer: "https://www.youtube.com/watch?v=JNwNXF9Y6kY",
		id: "tt0080684",
		description:
			"The epic saga continues as Luke Skywalker, in hopes of defeating the evil Galactic Empire, learns the ways of the Jedi from aging master Yoda. But Darth Vader is more determined than ever to capture Luke. Meanwhile, rebel leader Princess Leia, cocky Han Solo, Chewbacca, and droids C-3PO and R2-D2 are thrown into various stages of capture, betrayal and despair.",
	},
	{
		rank: 16,
		movie_name: "The Matrix",
		movie_year: "1999",
		genre: ["Action", "Sci-Fi"],
		director_name: "Lana Wachowski",
		rating: "8.7",
		actors_list: [
			"Keanu Reeves",
			"Laurence Fishburne",
			"Carrie-Anne Moss",
			"Hugo Weaving",
			"Gloria Foster",
			"Joe Pantoliano",
			"Marcus Chong",
			"Julian Arahanga",
			"Matt Doran",
			"Belinda McClory",
			"Anthony Ray Parker",
			"Paul Goddard",
			"Robert Taylor",
			"David Aston",
			"Marc Aden Gray",
			"Ada Nicodemou",
			"Deni Gordon",
			"Rowan Witt",
		],
		trailer: "https://www.youtube.com/watch?v=vKQi3bBA1y8",
		id: "tt0133093",
		description:
			"Set in the 22nd century, The Matrix tells the story of a computer hacker who joins a group of underground insurgents fighting the vast and powerful computers who now rule the earth.",
	},
	{
		rank: 17,
		movie_name: "Goodfellas",
		movie_year: "1990",
		genre: ["Biography", "Crime", "Drama"],
		director_name: "Martin Scorsese",
		rating: "8.7",
		actors_list: [
			"Robert De Niro",
			"Ray Liotta",
			"Joe Pesci",
			"Lorraine Bracco",
			"Paul Sorvino",
			"Frank Sivero",
			"Tony Darrow",
			"Mike Starr",
			"Frank Vincent",
			"Chuck Low",
			"Frank DiLeo",
			"Henny Youngman",
			"Gina Mastrogiacomo",
			"Catherine Scorsese",
			"Charles Scorsese",
			"Suzanne Shepherd",
			"Debi Mazar",
			"Margo Winkler",
		],
		trailer: "https://www.youtube.com/watch?v=2ilzidi_J8Q",
		id: "tt0099685",
		description:
			"The true story of Henry Hill, a half-Irish, half-Sicilian Brooklyn kid who is adopted by neighbourhood gangsters at an early age and climbs the ranks of a Mafia family under the guidance of Jimmy Conway.",
	},
	{
		rank: 18,
		movie_name: "One Flew Over the Cuckoo's Nest",
		movie_year: "1975",
		genre: ["Drama"],
		director_name: "Milos Forman",
		rating: "8.7",
		actors_list: [
			"Jack Nicholson",
			"Louise Fletcher",
			"Michael Berryman",
			"Peter Brocco",
			"Dean R. Brooks",
			"Alonzo Brown",
			"Scatman Crothers",
			"Mwako Cumbuka",
			"Danny DeVito",
			"William Duell",
			"Josip Elic",
			"Lan Fendors",
			"Nathan George",
			"Ken Kenny",
			"Mel Lambert",
			"Sydney Lassick",
			"Kay Lee",
			"Christopher Lloyd",
		],
		trailer: "https://www.youtube.com/watch?v=OXrcDonY-B8",
		id: "tt0073486",
		description:
			"A petty criminal fakes insanity to serve his sentence in a mental ward rather than prison. He soon finds himself as a leader to the other patients—and an enemy to the cruel, domineering nurse who runs the ward.",
	},
	{
		rank: 19,
		movie_name: "Se7en",
		movie_year: "1995",
		genre: ["Crime", "Drama", "Mystery"],
		director_name: "David Fincher",
		rating: "8.6",
		actors_list: [
			"Morgan Freeman",
			"Brad Pitt",
			"Kevin Spacey",
			"Andrew Kevin Walker",
			"Daniel Zacapa",
			"Gwyneth Paltrow",
			"John Cassini",
			"Bob Mack",
			"Peter Crombie",
			"Reg E. Cathey",
			"R. Lee Ermey",
			"George Christy",
			"Endre Hules",
			"Hawthorne James",
			"William Davidson",
			"Bob Collins",
			"Jimmy Dale Hartsell",
			"Richard Roundtree",
		],
		trailer: "https://www.youtube.com/watch?v=znmZoVkCjpI",
		id: "tt0114369",
		description:
			"Two homicide detectives are on a desperate hunt for a serial killer whose crimes are based on the 'seven deadly sins' in this dark and haunting film that takes viewers from the tortured remains of one victim to the next. The seasoned Det. Sommerset researches each sin in an effort to get inside the killer's mind, while his novice partner, Mills, scoffs at his efforts to unravel the case.",
	},
	{
		rank: 20,
		movie_name: "Seven Samurai",
		movie_year: "1954",
		genre: ["Action", "Drama"],
		director_name: "Akira Kurosawa",
		rating: "8.6",
		actors_list: [
			"Toshirô Mifune",
			"Takashi Shimura",
			"Keiko Tsushima",
			"Yukiko Shimazaki",
			"Kamatari Fujiwara",
			"Daisuke Katô",
			"Isao Kimura",
			"Minoru Chiaki",
			"Seiji Miyaguchi",
			"Yoshio Kosugi",
			"Bokuzen Hidari",
			"Yoshio Inaba",
			"Yoshio Tsuchiya",
			"Kokuten Kôdô",
			"Eijirô Tôno",
			"Kichijirô Ueda",
			"Jun Tatara",
			"Atsushi Watanabe",
		],
		trailer: "https://www.youtube.com/watch?v=wJ1TOratCTo",
		id: "tt0047478",
		description:
			"A samurai answers a village's request for protection after he falls on hard times. The town needs protection from bandits, so the samurai gathers six others to help him teach the people how to defend themselves, and the villagers provide the soldiers with food. A giant battle occurs when 40 bandits attack the village.",
	},
	{
		rank: 21,
		movie_name: "It's a Wonderful Life",
		movie_year: "1946",
		genre: ["Drama", "Family", "Fantasy"],
		director_name: "Frank Capra",
		rating: "8.6",
		actors_list: [
			"James Stewart",
			"Donna Reed",
			"Lionel Barrymore",
			"Thomas Mitchell",
			"Henry Travers",
			"Beulah Bondi",
			"Frank Faylen",
			"Ward Bond",
			"Gloria Grahame",
			"H.B. Warner",
			"Frank Albertson",
			"Todd Karns",
			"Samuel S. Hinds",
			"Mary Treen",
			"Virginia Patton",
			"Charles Williams",
			"Sarah Edwards",
			"William Edmunds",
		],
		trailer: "https://www.youtube.com/watch?v=iLR3gZrU2Xo",
		id: "tt0038650",
		description:
			"A holiday favourite for generations... George Bailey has spent his entire life giving to the people of Bedford Falls. All that prevents rich skinflint Mr. Potter from taking over the entire town is George's modest building and loan company. But on Christmas Eve the business's $8,000 is lost and George's troubles begin.",
	},
	{
		rank: 22,
		movie_name: "The Silence of the Lambs",
		movie_year: "1991",
		genre: ["Crime", "Drama", "Thriller"],
		director_name: "Jonathan Demme",
		rating: "8.6",
		actors_list: [
			"Jodie Foster",
			"Anthony Hopkins",
			"Lawrence A. Bonney",
			"Kasi Lemmons",
			"Lawrence T. Wrentz",
			"Scott Glenn",
			"Anthony Heald",
			"Frankie Faison",
			"Don Brockett",
			"Frank Seals Jr.",
			"Stuart Rudin",
			"Maria Skorobogatov",
			"Jeffrie Lane",
			"Leib Lensky",
			"George 'Red' Schwartz",
			"Jim Roche",
			"Brooke Smith",
			"Ted Levine",
		],
		trailer: "https://www.youtube.com/watch?v=6iB21hsprAQ",
		id: "tt0102926",
		description:
			"Clarice Starling is a top student at the FBI's training academy. Jack Crawford wants Clarice to interview Dr. Hannibal Lecter, a brilliant psychiatrist who is also a violent psychopath, serving life behind bars for various acts of murder and cannibalism. Crawford believes that Lecter may have insight into a case and that Starling, as an attractive young woman, may be just the bait to draw him out.",
	},
	{
		rank: 23,
		movie_name: "City of God",
		movie_year: "2002",
		genre: ["Crime", "Drama"],
		director_name: "Fernando Meirelles",
		rating: "8.6",
		actors_list: [
			"Alexandre Rodrigues",
			"Leandro Firmino",
			"Matheus Nachtergaele",
			"Phellipe Haagensen",
			"Douglas Silva",
			"Jonathan Haagensen",
			"Seu Jorge",
			"Jefechander Suplino",
			"Alice Braga",
			"Emerson Gomes",
			"Edson Oliveira",
			"Michel Gomes",
			"Roberta Rodrigues",
			"Luis Otávio",
			"Kiko Marques",
			"Gustavo Engrácia",
			"Darlan Cunha",
			"Robson Rocha",
		],
		trailer: "https://www.youtube.com/watch?v=dcUOO4Itgmw",
		id: "tt0317248",
		description:
			"In the slums of Rio, two kids' paths diverge as one struggles to become a photographer and the other a kingpin.",
	},
	{
		rank: 24,
		movie_name: "Saving Private Ryan",
		movie_year: "1998",
		genre: ["Drama", "War"],
		director_name: "Steven Spielberg",
		rating: "8.6",
		actors_list: [
			"Tom Hanks",
			"Matt Damon",
			"Tom Sizemore",
			"Edward Burns",
			"Barry Pepper",
			"Adam Goldberg",
			"Vin Diesel",
			"Giovanni Ribisi",
			"Jeremy Davies",
			"Ted Danson",
			"Paul Giamatti",
			"Dennis Farina",
			"Joerg Stadler",
			"Max Martini",
			"Dylan Bruno",
			"Daniel Cerqueira",
			"Demetri Goritsas",
			"Ian Porter",
		],
		trailer: "https://www.youtube.com/watch?v=9CiW_DgxCnQ",
		id: "tt0120815",
		description:
			"As U.S. troops storm the beaches of Normandy, three brothers lie dead on the battlefield, with a fourth trapped behind enemy lines. Ranger captain John Miller and seven men are tasked with penetrating German-held territory and bringing the boy home.",
	},
	{
		rank: 25,
		movie_name: "Life Is Beautiful",
		movie_year: "1997",
		genre: ["Comedy", "Drama", "Romance"],
		director_name: "Roberto Benigni",
		rating: "8.6",
		actors_list: [
			"Roberto Benigni",
			"Nicoletta Braschi",
			"Giorgio Cantarini",
			"Giustino Durano",
			"Sergio Bini Bustric",
			"Marisa Paredes",
			"Horst Buchholz",
			"Lidia Alfonsi",
			"Giuliana Lojodice",
			"Amerigo Fontani",
			"Pietro De Silva",
			"Francesco Guzzo",
			"Raffaella Lebboroni",
			"Claudio Alfonsi",
			"Gil Baroni",
			"Massimo Bianchi",
			"Jürgen Bohn",
			"Verena Buratti",
		],
		trailer: "https://www.youtube.com/watch?v=8CTjcVr9Iao",
		id: "tt0118799",
		description:
			"As U.S. troops storm the beaches of Normandy, three brothers lie dead on the battlefield, with a fourth trapped behind enemy lines. Ranger captain John Miller and seven men are tasked with penetrating German-held territory and bringing the boy home.",
	},
	{
		rank: 26,
		movie_name: "The Green Mile",
		movie_year: "1999",
		genre: ["Crime", "Drama", "Fantasy"],
		director_name: "Frank Darabont",
		rating: "8.6",
		actors_list: [
			"Tom Hanks",
			"Michael Clarke Duncan",
			"David Morse",
			"Bonnie Hunt",
			"James Cromwell",
			"Michael Jeter",
			"Graham Greene",
			"Doug Hutchison",
			"Sam Rockwell",
			"Barry Pepper",
			"Jeffrey DeMunn",
			"Patricia Clarkson",
			"Harry Dean Stanton",
			"Dabbs Greer",
			"Eve Brent",
			"William Sadler",
			"Mack Miles",
			"Rai Tasco",
		],
		trialer: "https://www.youtube.com/watch?v=Ki4haFrqSrw",
		id: "tt0120689",
		description:
			"A supernatural tale set on death row in a Southern prison, where gentle giant John Coffey possesses the mysterious power to heal people's ailments. When the cell block's head guard, Paul Edgecomb, recognizes Coffey's miraculous gift, he tries desperately to help stave off the condemned man's execution.",
	},
	{
		rank: 27,
		movie_name: "Interstellar",
		movie_year: "2014",
		genre: ["Adventure", "Drama", "Sci-Fi"],
		director_name: "Christopher Nolan",
		rating: "8.6",
		actors_list: [
			"Matthew McConaughey",
			"Anne Hathaway",
			"Jessica Chastain",
			"Mackenzie Foy",
			"Ellen Burstyn",
			"John Lithgow",
			"Timothée Chalamet",
			"David Oyelowo",
			"Collette Wolfe",
			"Francis X. McCarthy",
			"Bill Irwin",
			"Andrew Borba",
			"Wes Bentley",
			"William Devane",
			"Michael Caine",
			"David Gyasi",
			"Josh Stewart",
			"Casey Affleck",
		],
		trailer: "https://www.youtube.com/watch?v=zSWdZVtXT7E&t=2s",
		id: "tt0816692",
		description:
			"The adventures of a group of explorers who make use of a newly discovered wormhole to surpass the limitations on human space travel and conquer the vast distances involved in an interstellar voyage.",
	},
	{
		rank: 28,
		movie_name: "Star Wars",
		movie_year: "1977",
		genre: ["Action", "Adventure", "Fantasy"],
		director_name: "George Lucas",
		rating: "8.6",
		actors_list: [
			"Mark Hamill",
			"Harrison Ford",
			"Carrie Fisher",
			"Alec Guinness",
			"Peter Cushing",
			"Anthony Daniels",
			"Kenny Baker",
			"Peter Mayhew",
			"David Prowse",
			"Phil Brown",
			"Shelagh Fraser",
			"Jack Purvis",
			"Alex McCrindle",
			"Eddie Byrne",
			"Drewe Henley",
			"Denis Lawson",
			"Garrick Hagon",
			"Jack Klaff",
		],
		trailer: "https://www.youtube.com/watch?v=vZ734NWnAHA",
		id: "tt0076759",
		description:
			"Princess Leia is captured and held hostage by the evil Imperial forces in their effort to take over the galactic Empire. Venturesome Luke Skywalker and dashing captain Han Solo team together with the loveable robot duo R2-D2 and C-3PO to rescue the beautiful princess and restore peace and justice in the Empire.",
	},
	{
		rank: 29,
		movie_name: "Terminator 2: Judgment Day",
		movie_year: "1991",
		genre: ["Action", "Sci-Fi"],
		director_name: "James Cameron",
		rating: "8.6",
		actors_list: [
			"Arnold Schwarzenegger",
			"Linda Hamilton",
			"Edward Furlong",
			"Robert Patrick",
			"Earl Boen",
			"Joe Morton",
			"S. Epatha Merkerson",
			"Castulo Guerra",
			"Danny Cooksey",
			"Jenette Goldstein",
			"Xander Berkeley",
			"Leslie Hamilton Gearren",
			"Ken Gibbel",
			"Robert Winley",
			"Peter Schrum",
			"Shane Wilder",
			"Michael Edwards",
			"Jared Lounsbery",
		],
		trailer: "https://www.youtube.com/watch?v=CRRlbK5w8AE",
		id: "tt0103064",
		description:
			"Princess Leia is captured and held hostage by the evil Imperial forces in their effort to take over the galactic Empire. Venturesome Luke Skywalker and dashing captain Han Solo team together with the loveable robot duo R2-D2 and C-3PO to rescue the beautiful princess and restore peace and justice in the Empire.",
	},
	{
		rank: 30,
		movie_name: "Back to the Future",
		movie_year: "1985",
		genre: ["Adventure", "Comedy", "Sci-Fi"],
		director_name: "Robert Zemeckis",
		rating: "8.5",
		actors_list: [
			"Michael J. Fox",
			"Christopher Lloyd",
			"Lea Thompson",
			"Crispin Glover",
			"Tom Wilson",
			"Claudia Wells",
			"Marc McClure",
			"Wendie Jo Sperber",
			"George DiCenzo",
			"Frances Lee McCain",
			"James Tolkan",
			"J.J. Cohen",
			"Casey Siemaszko",
			"Billy Zane",
			"Harry Waters Jr.",
			"Donald Fullilove",
			"Lisa Freeman",
			"Cristen Kauffman",
		],
		trailer: "https://www.youtube.com/watch?v=qvsgGtivCgs",
		id: "tt0088763",
		description:
			"Set ten years after the events of the original, James Cameron’s classic sci-fi action flick tells the story of a second attempt to get the rid of rebellion leader John Connor, this time targeting the boy himself. However, the rebellion has sent a reprogrammed terminator to protect Connor.",
	},
	{
		rank: 31,
		movie_name: "Spirited Away",
		movie_year: "2001",
		genre: ["Animation", "Adventure", "Family"],
		director_name: "Hayao Miyazaki",
		rating: "8.6",
		actors_list: [
			"Daveigh Chase",
			"Suzanne Pleshette",
			"Miyu Irino",
			"Rumi Hiiragi",
			"Mari Natsuki",
			"Takashi Naitô",
			"Yasuko Sawaguchi",
			"Tatsuya Gashûin",
			"Ryûnosuke Kamiki",
			"Yumi Tamai",
			"Yô Ôizumi",
			"Koba Hayashi",
			"Tsunehiko Kamijô",
			"Takehiko Ono",
			"Bunta Sugawara",
			"Shigeru Wakita",
			"Shirô Saitô",
			"Michiko Yamamoto",
		],
		trailer: "https://www.youtube.com/watch?v=ByXuk9QqQkk",
		id: "tt0245429",
		description:
			"A young girl, Chihiro, becomes trapped in a strange new world of spirits. When her parents undergo a mysterious transformation, she must call upon the courage she never knew she had to free her family.",
	},
	{
		rank: 32,
		movie_name: "Psycho",
		movie_year: "1960",
		genre: ["Horror", "Mystery", "Thriller"],
		director_name: "Alfred Hitchcock",
		rating: "8.5",
		actors_list: [
			"Anthony Perkins",
			"Janet Leigh",
			"Vera Miles",
			"John Gavin",
			"Martin Balsam",
			"John McIntire",
			"Simon Oakland",
			"Frank Albertson",
			"Patricia Hitchcock",
			"Vaughn Taylor",
			"Lurene Tuttle",
			"John Anderson",
			"Mort Mills",
			"Fletcher Allen",
			"Walter Bacon",
			"Prudence Beers",
			"Kit Carson",
			"Francis De Sales",
		],
		trailer: "https://www.youtube.com/watch?v=NG3-GlvKPcg",
		id: "tt0054215",
		description:
			"When larcenous real estate clerk Marion Crane goes on the lam with a wad of cash and hopes of starting a new life, she ends up at the notorious Bates Motel, where manager Norman Bates cares for his housebound mother.",
	},
	{
		rank: 33,
		movie_name: "The Pianist",
		movie_year: "2002",
		genre: ["Biography", "Drama", "Music"],
		director_name: "Roman Polanski",
		rating: "8.5",
		actors_list: [
			"Adrien Brody",
			"Thomas Kretschmann",
			"Frank Finlay",
			"Emilia Fox",
			"Michal Zebrowski",
			"Ed Stoppard",
			"Maureen Lipman",
			"Jessica Kate Meyer",
			"Julia Rayner",
			"Wanja Mues",
			"Richard Ridings",
			"Nomi Sharron",
			"Anthony Milner",
			"Lucy Skeaping",
			"Roddy Skeaping",
			"Ben Harlan",
			"Thomas Lawinky",
			"Joachim Paul Assböck",
		],
		trailer: "https://www.youtube.com/watch?v=BFwGqLa_oAo",
		id: "tt0253474",
		description:
			"When larcenous real estate clerk Marion Crane goes on the lam with a wad of cash and hopes of starting a new life, she ends up at the notorious Bates Motel, where manager Norman Bates cares for his housebound mother.",
	},
	{
		rank: 34,
		movie_name: "Léon: The Professional",
		movie_year: "1994",
		genre: ["Action", "Crime", "Drama"],
		director_name: "Luc Besson",
		rating: "8.5",
		actors_list: [
			"Jean Reno",
			"Gary Oldman",
			"Natalie Portman",
			"Danny Aiello",
			"Peter Appel",
			"Willi One Blood",
			"Don Creech",
			"Keith A. Glascoe",
			"Randolph Scott",
			"Michael Badalucco",
			"Ellen Greene",
			"Elizabeth Regen",
			"Carl J. Matusovich",
			"Frank Senger",
			"Lucius Wyatt Cherokee",
			"Eric Challier",
			"Luc Bernard",
			"Maïwenn",
		],
		trailer: "https://www.youtube.com/watch?v=aNQqoExfQsg",
		id: "tt0110413",
		description:
			"The true story of pianist Władysław Szpilman's experiences in Warsaw during the Nazi occupation. When the Jews of the city find themselves forced into a ghetto, Szpilman finds work playing in a café; and when his family is deported in 1942, he stays behind, works for a while as a laborer, and eventually goes into hiding in the ruins of the war-torn city.",
	},
	{
		rank: 35,
		movie_name: "Parasite",
		movie_year: "2019",
		genre: ["Comedy", "Drama", "Thriller"],
		director_name: "Bong Joon Ho",
		rating: "8.5",
		actors_list: [
			"Song Kang-ho",
			"Sun-kyun Lee",
			"Cho Yeo-jeong",
			"Choi Woo-sik",
			"So-dam Park",
			"Lee Jeong-eun",
			"Jang Hye-jin",
			"Park Myeong-hoon",
			"Ji-so Jung",
			"Hyun-jun Jung",
			"Keun-rok Park",
			"Yi-Seo Jung",
			"Jae-myeong Jo",
			"Ik-han Jung",
			"Kyu-baek Kim",
			"Hwang In Kyung",
			"Ahn Seong-Bong",
			"Kim Jin Hyung",
		],
		trailer: "https://www.youtube.com/watch?v=isOGD_7hNIY",
		id: "tt6751668",
		description:
			"All unemployed, Ki-taek's family takes peculiar interest in the wealthy and glamorous Parks for their livelihood until they get entangled in an unexpected incident.",
	},
	{
		rank: 36,
		movie_name: "The Lion King",
		movie_year: "1994",
		genre: ["Animation", "Adventure", "Drama"],
		director_name: "Roger Allers",
		rating: "8.5",
		actors_list: [
			"Matthew Broderick",
			"Jeremy Irons",
			"James Earl Jones",
			"Whoopi Goldberg",
			"Rowan Atkinson",
			"Niketa Calame-Harris",
			"Jim Cummings",
			"Robert Guillaume",
			"Moira Kelly",
			"Nathan Lane",
			"Zoe Leader",
			"Cheech Marin",
			"Ernie Sabella",
			"Madge Sinclair",
			"Jonathan Taylor Thomas",
			"Frank Welker",
			"Cathy Cavadini",
			"Judi M. Durand",
		],
		trailer: "https://www.youtube.com/watch?v=lFzVJEksoDY",
		id: "tt0110357",
		description:
			"A young lion prince is cast out of his pride by his cruel uncle, who claims he killed his father. While the uncle rules with an iron paw, the prince grows up beyond the Savannah, living by a philosophy: No worries for the rest of your days. But when his past comes to haunt him, the young prince must decide his fate: Will he remain an outcast or face his demons and become what he needs to be?",
	},
	{
		rank: 37,
		movie_name: "Gladiator",
		movie_year: "2000",
		genre: ["Action", "Adventure", "Drama"],
		director_name: "Ridley Scott",
		rating: "8.5",
		actors_list: [
			"Russell Crowe",
			"Joaquin Phoenix",
			"Connie Nielsen",
			"Oliver Reed",
			"Richard Harris",
			"Derek Jacobi",
			"Djimon Hounsou",
			"David Schofield",
			"John Shrapnel",
			"Tomas Arana",
			"Ralf Moeller",
			"Spencer Treat Clark",
			"David Hemmings",
			"Tommy Flanagan",
			"Sven-Ole Thorsen",
			"Omid Djalili",
			"Nicholas McGaughey",
			"Chris Kell",
		],
		trailer: "https://www.youtube.com/watch?v=P5ieIbInFpg",
		id: "tt0172495",
		description:
			"In the year 180, the death of emperor Marcus Aurelius throws the Roman Empire into chaos. Maximus is one of the Roman army's most capable and trusted generals and a key advisor to the emperor. As Marcus' devious son Commodus ascends to the throne, Maximus is set to be executed. He escapes, but is captured by slave traders. Renamed Spaniard and forced to become a gladiator, Maximus must battle to the death with other men for the amusement of paying audiences.",
	},
	{
		rank: 38,
		movie_name: "American History X",
		movie_year: "1998",
		genre: ["Crime", "Drama"],
		director_name: "Tony Kaye",
		rating: "8.5",
		actors_list: [
			"Edward Norton",
			"Edward Furlong",
			"Beverly D'Angelo",
			"Jennifer Lien",
			"Ethan Suplee",
			"Fairuza Balk",
			"Avery Brooks",
			"Elliott Gould",
			"Stacy Keach",
			"William Russ",
			"Guy Torry",
			"Joe Cortese",
			"Jason Bose Smith",
			"Antonio David Lyons",
			"Alex Sol",
			"Keram Malicki-Sánchez",
			"Giuseppe Andrews",
			"Michelle Christine White",
		],
		trailer: "https://www.youtube.com/watch?v=XfQYHqsiN5g",
		id: "tt0120586",
		description:
			"Derek Vineyard is paroled after serving 3 years in prison for killing two African-American men. Through his brother, Danny Vineyard's narration, we learn that before going to prison, Derek was a skinhead and the leader of a violent white supremacist gang that committed acts of racial crime throughout L.A. and his actions greatly influenced Danny. Reformed and fresh out of prison, Derek severs contact with the gang and becomes determined to keep Danny from going down the same violent path as he did.",
	},
	{
		rank: 39,
		movie_name: "The Usual Suspects",
		movie_year: "1995",
		genre: ["Crime", "Drama", "Mystery"],
		director_name: "Bryan Singer",
		rating: "8.5",
		actors_list: [
			"Kevin Spacey",
			"Gabriel Byrne",
			"Chazz Palminteri",
			"Stephen Baldwin",
			"Benicio Del Toro",
			"Kevin Pollak",
			"Pete Postlethwaite",
			"Suzy Amis",
			"Giancarlo Esposito",
			"Dan Hedaya",
			"Paul Bartel",
			"Carl Bressler",
			"Phillipe Simon",
			"Jack Shearer",
			"Christine Estabrook",
			"Clark Gregg",
			"Morgan Hunter",
			"Ken Daly",
		],
		trailer: "https://www.youtube.com/watch?v=x3t0Nc6fg7w",
		id: "tt0114814",
		description:
			"Held in an L.A. interrogation room, Verbal Kint attempts to convince the feds that a mythic crime lord, Keyser Soze, not only exists, but was also responsible for drawing him and his four partners into a multi-million dollar heist that ended with an explosion in San Pedro harbor – leaving few survivors. Verbal lures his interrogators with an incredible story of the crime lord's almost supernatural prowess.",
	},
	{
		rank: 40,
		movie_name: "The Departed",
		movie_year: "2006",
		genre: ["Crime", "Drama", "Thriller"],
		director_name: "Martin Scorsese",
		rating: "8.5",
		actors_list: [
			"Leonardo DiCaprio",
			"Matt Damon",
			"Jack Nicholson",
			"Mark Wahlberg",
			"Martin Sheen",
			"Ray Winstone",
			"Vera Farmiga",
			"Anthony Anderson",
			"Alec Baldwin",
			"Kevin Corrigan",
			"James Badge Dale",
			"David O'Hara",
			"Mark Rolston",
			"Robert Wahlberg",
			"Kristen Dalton",
			"Thomas B. Duffy",
			"Richard Hughes",
			"J.C. MacKenzie",
		],
		trailer: "https://www.youtube.com/watch?v=r-MiSNsCdQ4",
		id: "tt0407887",
		description:
			"To take down South Boston's Irish Mafia, the police send in one of their own to infiltrate the underworld, not realizing the syndicate has done likewise. While an undercover cop curries favor with the mob kingpin, a career criminal rises through the police ranks. But both sides soon discover there's a mole among them.",
	},
	{
		rank: 41,
		movie_name: "The Prestige",
		movie_year: "2006",
		genre: ["Drama", "Mystery", "Sci-Fi"],
		director_name: "Christopher Nolan",
		rating: "8.5",
		actors_list: [
			"Christian Bale",
			"Hugh Jackman",
			"Scarlett Johansson",
			"Michael Caine",
			"Piper Perabo",
			"Rebecca Hall",
			"Samantha Mahurin",
			"David Bowie",
			"Andy Serkis",
			"Daniel Davis",
			"Jim Piddock",
			"Christopher Neame",
			"Mark Ryan",
			"Roger Rees",
			"Jamie Harris",
			"Monty Stuart",
			"Ron Perkins",
			"Ricky Jay",
		],
		trailer: "https://www.youtube.com/watch?v=RLtaA9fFNXU",
		id: "tt0482571",
		description:
			"A mysterious story of two magicians whose intense rivalry leads them on a life-long battle for supremacy -- full of obsession, deceit and jealousy with dangerous and deadly consequences.",
	},
	{
		rank: 42,
		movie_name: "Casablanca",
		movie_year: "1942",
		genre: ["Drama", "Romance", "War"],
		director_name: "Michael Curtiz",
		rating: "8.5",
		actors_list: [
			"Humphrey Bogart",
			"Ingrid Bergman",
			"Paul Henreid",
			"Claude Rains",
			"Conrad Veidt",
			"Sydney Greenstreet",
			"Peter Lorre",
			"S.Z. Sakall",
			"Madeleine Lebeau",
			"Dooley Wilson",
			"Joy Page",
			"John Qualen",
			"Leonid Kinskey",
			"Curt Bois",
			"Abdullah Abbas",
			"Enrique Acosta",
			"Ed Agresti",
			"Arnet Amos",
		],
		trailer: "https://www.youtube.com/watch?v=MF7JH_54d8c",
		id: "tt0034583",
		description:
			"A mysterious story of two magicians whose intense rivalry leads them on a life-long battle for supremacy -- full of obsession, deceit and jealousy with dangerous and deadly consequences.",
	},
	{
		rank: 43,
		movie_name: "Whiplash",
		movie_year: "2014",
		genre: ["Drama", "Music"],
		director_name: "Damien Chazelle",
		rating: "8.5",
		actors_list: [
			"Miles Teller",
			"J.K. Simmons",
			"Melissa Benoist",
			"Paul Reiser",
			"Austin Stowell",
			"Nate Lang",
			"Chris Mulkey",
			"Damon Gupton",
			"Suanne Spoke",
			"Max Kasch",
			"Charlie Ian",
			"Jayson Blair",
			"Kofi Siriboe",
			"Kavita Patil",
			"C.J. Vana",
			"Tarik Lowe",
			"Tyler Kimball",
			"Rogelio Douglas Jr.",
		],
		trailer: "https://www.youtube.com/watch?v=7d_jQycdQGo",
		id: "tt2582802",
		description:
			"Under the direction of a ruthless instructor, a talented young drummer begins to pursue perfection at any cost, even his humanity.",
	},
	{
		rank: 44,
		movie_name: "The Intouchables",
		movie_year: "2011",
		genre: ["Biography", "Comedy", "Drama"],
		director_name: "Olivier Nakache",
		rating: "8.5",
		actors_list: [
			"François Cluzet",
			"Omar Sy",
			"Anne Le Ny",
			"Audrey Fleurot",
			"Joséphine de Meaux",
			"Clotilde Mollet",
			"Alba Gaïa Bellugi",
			"Cyril Mendy",
			"Salimata Kamate",
			"Absa Diatou Toure",
			"Grégoire Oestermann",
			"Dominique Daguier",
			"François Caron",
			"Christian Ameri",
			"Thomas Solivérès",
			"Dorothée Brière",
			"Marie-Laure Descoureaux",
			"Émilie Caen",
		],
		trailer: "https://www.youtube.com/watch?v=34WIbmXkewU",
		id: "tt1675434",
		description:
			"A true story of two men who should never have met – a quadriplegic aristocrat who was injured in a paragliding accident and a young man from the projects.",
	},
	{
		rank: 45,
		movie_name: "Top Gun: Maverick",
		movie_year: "2022",
		genre: ["Action", "Drama"],
		director_name: "Joseph Kosinski",
		rating: "8.6",
		actors_list: [
			"Tom Cruise",
			"Jennifer Connelly",
			"Miles Teller",
			"Val Kilmer",
			"Bashir Salahuddin",
			"Jon Hamm",
			"Charles Parnell",
			"Monica Barbaro",
			"Lewis Pullman",
			"Jay Ellis",
			"Danny Ramirez",
			"Glen Powell",
			"Jack Schumacher",
			"Manny Jacinto",
			"Kara Wang",
			"Greg Tarzan Davis",
			"Jake Picking",
			"Raymond Lee",
		],
		trailer: "https://www.youtube.com/watch?v=qSqVVswa420",
		id: "tt1745960",
		description:
			"Set in the world of drone technology and fifth generation fighters, this sequel will explore the end of the era of dogfighting.",
	},
	{
		rank: 46,
		movie_name: "Modern Times",
		movie_year: "1936",
		genre: ["Comedy", "Drama", "Romance"],
		director_name: "Charles Chaplin",
		rating: "8.5",
		actors_list: [
			"Charles Chaplin",
			"Paulette Goddard",
			"Henry Bergman",
			"Tiny Sandford",
			"Chester Conklin",
			"Hank Mann",
			"Stanley Blystone",
			"Al Ernest Garcia",
			"Richard Alexander",
			"Cecil Reynolds",
			"Mira McKinney",
			"Murdock MacQuarrie",
			"Wilfred Lucas",
			"Edward LeSaint",
			"Fred Malatesta",
			"Sammy Stein",
			"Juana Sutton",
			"Ted Oliver",
		],
		trailer: "https://www.youtube.com/watch?v=GLeDdzGUTq0",
		id: "tt0027977",
		description:
			"A bumbling tramp desires to build a home with a young woman, yet is thwarted time and time again by his lack of experience and habit of being in the wrong place at the wrong time..",
	},
	{
		rank: 47,
		movie_name: "Seppuku",
		movie_year: "1962",
		genre: ["Action", "Drama", "Mystery"],
		director_name: "Masaki Kobayashi",
		rating: "8.6",
		actors_list: [
			"Tatsuya Nakadai",
			"Akira Ishihama",
			"Shima Iwashita",
			"Tetsurô Tanba",
			"Masao Mishima",
			"Ichirô Nakatani",
			"Kei Satô",
			"Yoshio Inaba",
			"Hisashi Igawa",
			"Tôru Takeuchi",
			"Yoshirô Aoki",
			"Tatsuo Matsumura",
			"Akiji Kobayashi",
			"Kôichi Hayashi",
			"Ryûtarô Gomi",
			"Jô Azumi",
			"Nakajirô Tomita",
			"Shichisaburô Amatsu",
		],
		trailer: "https://www.youtube.com/watch?v=gfABwM-Ppng",
		id: "tt0056058",
		description:
			"Down-on-his-luck veteran Tsugumo Hanshirō enters the courtyard of the prosperous House of Iyi. Unemployed, and with no family, he hopes to find a place to commit seppuku—and a worthy second to deliver the coup de grâce in his suicide ritual. The senior counselor for the Iyi clan questions the ronin’s resolve and integrity, suspecting Hanshirō of seeking charity rather than an honorable end. What follows is a pair of interlocking stories which lay bare the difference between honor and respect, and promises to examine the legendary foundations of the Samurai code.",
	},
	{
		rank: 48,
		movie_name: "Grave of the Fireflies",
		movie_year: "1988",
		genre: ["Animation", "Drama", "War"],
		director_name: "Isao Takahata",
		rating: "8.5",
		actors_list: [
			"Tsutomu Tatsumi",
			"Ayano Shiraishi",
			"Akemi Yamaguchi",
			"Yoshiko Shinohara",
			"Kôzô Hashida",
			"Masayo Sakai",
			"Kazumi Nozaki",
			"Yoshio Matsuoka",
			"Masahiro Kanetake",
			"Kiyoshi Yanagawa",
			"Hajime Maki",
			"Atsuo Omote",
			"Teruhisa Harita",
			"Hiroshi Tanaka",
			"Michio Denpô",
			"Shirô Tamaki",
			"Tadashi Nakamura",
			"Mika Sekita",
		],
		trailer: "https://www.youtube.com/watch?v=4vPeTSRd580",
		id: "tt0095327",
		description:
			"In the final months of World War II, 14-year-old Seita and his sister Setsuko are orphaned when their mother is killed during an air raid in Kobe, Japan. After a falling out with their aunt, they move into an abandoned bomb shelter. With no surviving relatives and their emergency rations depleted, Seita and Setsuko struggle to survive.",
	},
	{
		rank: 49,
		movie_name: "Once Upon a Time in the West",
		movie_year: "1968",
		genre: ["Western"],
		director_name: "Sergio Leone",
		rating: "8.5",
		actors_list: [
			"Henry Fonda",
			"Charles Bronson",
			"Claudia Cardinale",
			"Jason Robards",
			"Gabriele Ferzetti",
			"Paolo Stoppa",
			"Woody Strode",
			"Jack Elam",
			"Keenan Wynn",
			"Frank Wolff",
			"Lionel Stander",
			"Livio Andronico",
			"Salvatore Basile",
			"Aldo Berti",
			"Joseph Bradley",
			"Frank Braña",
			"Marilù Carteny",
			"Saturno Cerra",
		],
		trailer: "https://www.youtube.com/watch?v=c8CJ6L0I6W8",
		id: "tt0064116",
		description:
			"As the railroad builders advance unstoppably through the Arizona desert on their way to the sea, Jill arrives in the small town of Flagstone with the intention of starting a new life.",
	},
	{
		rank: 50,
		movie_name: "Rear Window",
		movie_year: "1954",
		genre: ["Mystery", "Thriller"],
		director_name: "Alfred Hitchcock",
		rating: "8.5",
		actors_list: [
			"James Stewart",
			"Grace Kelly",
			"Wendell Corey",
			"Thelma Ritter",
			"Raymond Burr",
			"Judith Evelyn",
			"Ross Bagdasarian",
			"Georgine Darcy",
			"Sara Berner",
			"Frank Cady",
			"Jesslyn Fax",
			"Rand Harper",
			"Irene Winston",
			"Havis Davenport",
			"Jerry Antes",
			"Barbara Bailey",
			"Benny Bartlett",
			"Nick Borgani",
		],
		trailer: "https://www.youtube.com/watch?v=m01YktiEZCw",
		id: "tt0047396",
		description:
			"A wheelchair-bound photographer spies on his neighbors from his apartment window and becomes convinced one of them has committed murder.",
	},
	{
		rank: 51,
		movie_name: "Alien",
		movie_year: "1979",
		genre: ["Horror", "Sci-Fi"],
		director_name: "Ridley Scott",
		rating: "8.5",
		actors_list: [
			"Sigourney Weaver",
			"Tom Skerritt",
			"John Hurt",
			"Veronica Cartwright",
			"Harry Dean Stanton",
			"Ian Holm",
			"Yaphet Kotto",
			"Bolaji Badejo",
			"Helen Horton",
			"Eddie Powell",
		],
		trailer: "https://www.youtube.com/watch?v=jQ5lPt9edzQ",
		id: "tt0078748",
		description:
			"During its return to the earth, commercial spaceship Nostromo intercepts a distress signal from a distant planet. When a three-member team of the crew discovers a chamber containing thousands of eggs on the planet, a creature inside one of the eggs attacks an explorer. The entire crew is unaware of the impending nightmare set to descend upon them when the alien parasite planted inside its unfortunate host is birthed.",
	},
	{
		rank: 52,
		movie_name: "City Lights",
		movie_year: "1931",
		genre: ["Comedy", "Drama", "Romance"],
		director_name: "Charles Chaplin",
		rating: "8.5",
		actors_list: [
			"Charles Chaplin",
			"Virginia Cherrill",
			"Florence Lee",
			"Harry Myers",
			"Al Ernest Garcia",
			"Hank Mann",
			"Johnny Aber",
			"Jack Alexander",
			"T.S. Alexander",
			"Victor Alexander",
			"Albert Austin",
			"Harry Ayers",
			"Eddie Baker",
			"Henry Bergman",
			"Edward Biby",
			"Betty Blair",
			"Buster Brodie",
			"Jeanne Carpenter",
		],
		trailer: "https://www.youtube.com/watch?v=7vl7F8S4cpQ",
		id: "tt0021749",
		description: "In this sound-era silent film, a tramp falls in love with a beautiful blind flower seller.",
	},
	{
		rank: 53,
		movie_name: "Cinema Paradiso",
		movie_year: "1988",
		genre: ["Drama", "Romance"],
		director_name: "Giuseppe Tornatore",
		rating: "8.5",
		actors_list: [
			"Philippe Noiret",
			"Enzo Cannavale",
			"Antonella Attili",
			"Isa Danieli",
			"Leo Gullotta",
			"Marco Leonardi",
			"Pupella Maggio",
			"Agnese Nano",
			"Leopoldo Trieste",
			"Salvatore Cascio",
			"Tano Cimarosa",
			"Nicola Di Pinto",
			"Roberta Lena",
			"Nino Terzo",
			"Jacques Perrin",
			"Nellina Laganà",
			"Turi Giuffrida",
			"Mariella Lo Giudice",
		],
		trailer: "https://www.youtube.com/watch?v=C2-GX0Tltgw",
		id: "tt0095765",
		description:
			"A filmmaker recalls his childhood, when he fell in love with the movies at his village's theater and formed a deep friendship with the theater's projectionist.",
	},
	{
		rank: 54,
		movie_name: "Memento",
		movie_year: "2000",
		genre: ["Mystery", "Thriller"],
		director_name: "Christopher Nolan",
		rating: "8.4",
		actors_list: [
			"Guy Pearce",
			"Carrie-Anne Moss",
			"Joe Pantoliano",
			"Mark Boone Junior",
			"Russ Fega",
			"Jorja Fox",
			"Stephen Tobolowsky",
			"Harriet Sansom Harris",
			"Thomas Lennon",
			"Callum Keith Rennie",
			"Kimberly Campbell",
			"Marianne Muellerleile",
			"Larry Holden",
			"Buzz Visconti",
		],
		trailer: "https://www.youtube.com/watch?v=4CV41hoyS8A",
		id: "tt0209144",
		description:
			"Leonard Shelby is tracking down the man who raped and murdered his wife. The difficulty of locating his wife's killer, however, is compounded by the fact that he suffers from a rare, untreatable form of short-term memory loss. Although he can recall details of life before his accident, Leonard cannot remember what happened fifteen minutes ago, where he's going, or why.",
	},
	{
		rank: 55,
		movie_name: "Apocalypse Now",
		movie_year: "1979",
		genre: ["Drama", "Mystery", "War"],
		director_name: "Francis Ford Coppola",
		rating: "8.5",
		actors_list: [
			"Martin Sheen",
			"Marlon Brando",
			"Robert Duvall",
			"Frederic Forrest",
			"Sam Bottoms",
			"Laurence Fishburne",
			"Albert Hall",
			"Harrison Ford",
			"Dennis Hopper",
			"G.D. Spradlin",
			"Jerry Ziesmer",
			"Scott Glenn",
			"Bo Byers",
			"James Keane",
			"Kerry Rossall",
			"Ron McQueen",
			"Tom Mason",
			"Cynthia Wood",
		],
		trailer: "https://www.youtube.com/watch?v=9l-ViOOFH-s",
		id: "tt0078788",
		description:
			"At the height of the Vietnam war, Captain Benjamin Willard is sent on a dangerous mission that, officially, 'does not exist, nor will it ever exist.' His goal is to locate - and eliminate - a mysterious Green Beret Colonel named Walter Kurtz, who has been leading his personal army on illegal guerrilla missions into enemy territory.",
	},
	{
		rank: 56,
		movie_name: "Raiders of the Lost Ark",
		movie_year: "1981",
		genre: ["Action", "Adventure"],
		director_name: "Steven Spielberg",
		rating: "8.4",
		actors_list: [
			"Harrison Ford",
			"Karen Allen",
			"Paul Freeman",
			"John Rhys-Davies",
			"Ronald Lacey",
			"Denholm Elliott",
			"Alfred Molina",
			"Wolf Kahler",
			"Anthony Higgins",
			"Vic Tablian",
			"Don Fellows",
			"William Hootkins",
			"Bill Reimbold",
			"Fred Sorenson",
			"Patrick Durkin",
			"Matthew Scurfield",
			"Malcolm Weaver",
			"Sonny Caldinez",
		],
		trailer: "https://www.youtube.com/watch?v=0xQSIdSRlAk",
		id: "tt0082971",
		description:
			"When Dr. Indiana Jones – the tweed-suited professor who just happens to be a celebrated archaeologist – is hired by the government to locate the legendary Ark of the Covenant, he finds himself up against the entire Nazi regime.",
	},
	{
		rank: 57,
		movie_name: "Django Unchained",
		movie_year: "2012",
		genre: ["Drama", "Western"],
		director_name: "Quentin Tarantino",
		rating: "8.4",
		actors_list: [
			"Jamie Foxx",
			"Christoph Waltz",
			"Leonardo DiCaprio",
			"Kerry Washington",
			"Samuel L. Jackson",
			"Walton Goggins",
			"Dennis Christopher",
			"James Remar",
			"David Steen",
			"Dana Gourrier",
			"Nichole Galicia",
			"Laura Cayouette",
			"Ato Essandoh",
			"Sammi Rotibi",
			"Clay Donahue Fontenot",
			"Escalante Lundy",
			"Miriam F. Glover",
			"Don Johnson",
		],
		trailer: "https://www.youtube.com/watch?v=0fUCuvNlOCg",
		id: "tt1853728",
		description:
			"With the help of a German bounty hunter, a freed slave sets out to rescue his wife from a brutal Mississippi plantation owner.",
	},
	{
		rank: 58,
		movie_name: "WALL·E",
		movie_year: "2008",
		genre: ["Animation", "Adventure", "Family"],
		director_name: "Andrew Stanton",
		rating: "8.4",
		actors_list: [
			"Ben Burtt",
			"Elissa Knight",
			"Jeff Garlin",
			"Fred Willard",
			"MacInTalk",
			"John Ratzenberger",
			"Kathy Najimy",
			"Sigourney Weaver",
			"Teddy Newton",
			"Bob Bergen",
			"John Cygan",
			"Pete Docter",
			"Paul Eiding",
			"Donald Fullilove",
			"Teresa Ganzel",
			"Jess Harnell",
			"Sherry Lynn",
			"Mickie McGowan",
		],
		trailer: "https://www.youtube.com/watch?v=CZ1CATNbXg0",
		id: "tt0910970",
		description:
			"In the distant future, Earth has become a desolate wasteland, abandoned by humanity and overrun by mountains of trash. Amidst the rubble, a small, lovable robot named WALL-E spends his days tirelessly cleaning up the mess. But when a sleek, high-tech robot named EVE arrives on a mission to search for signs of life, WALL-E is immediately smitten. Together, they embark on a journey across the cosmos.",
	},
	{
		rank: 59,
		movie_name: "The Lives of Others",
		movie_year: "2006",
		genre: ["Drama", "Mystery", "Thriller"],
		director_name: "Florian Henckel von Donnersmarck",
		rating: "8.4",
		actors_list: [
			"Ulrich Mühe",
			"Martina Gedeck",
			"Sebastian Koch",
			"Ulrich Tukur",
			"Thomas Thieme",
			"Hans-Uwe Bauer",
			"Volkmar Kleinert",
			"Matthias Brenner",
			"Charly Hübner",
			"Herbert Knaup",
			"Bastian Trost",
			"Marie Gruber",
			"Volker Michalowski",
			"Werner Daehn",
			"Martin Brambach",
			"Hubertus Hartmann",
			"Thomas Arnold",
			"Hinnerk Schönemann",
		],
		trailer: "https://www.youtube.com/watch?v=YsShZNHmpGE",
		id: "tt0405094",
		description:
			"In 1984 East Berlin, an agent of the secret police, conducting surveillance on a writer and his lover, finds himself becoming increasingly absorbed by their lives.",
	},
	{
		rank: 60,
		movie_name: "Sunset Blvd.",
		movie_year: "1950",
		genre: ["Drama", "Film-Noir"],
		director_name: "Billy Wilder",
		rating: "8.4",
		actors_list: [
			"William Holden",
			"Gloria Swanson",
			"Erich von Stroheim",
			"Nancy Olson",
			"Fred Clark",
			"Lloyd Gough",
			"Jack Webb",
			"Franklyn Farnum",
			"Larry J. Blake",
			"Charles Dayton",
			"Cecil B. DeMille",
			"Hedda Hopper",
			"Buster Keaton",
			"Anna Q. Nilsson",
			"H.B. Warner",
			"Ray Evans",
			"Jay Livingston",
			"Fred Aldrich",
		],
		trailer: "https://www.youtube.com/watch?v=_dY0SVxnHjQ",
		id: "tt0043014",
		description:
			"A hack screenwriter writes a screenplay for a former silent film star who has faded into Hollywood obscurity.",
	},
	{
		rank: 61,
		movie_name: "Paths of Glory",
		movie_year: "1957",
		genre: ["Drama", "War"],
		director_name: "Stanley Kubrick",
		rating: "8.4",
		actors_list: [
			"Kirk Douglas",
			"Ralph Meeker",
			"Adolphe Menjou",
			"George Macready",
			"Wayne Morris",
			"Richard Anderson",
			"Joe Turkel",
			"Christiane Kubrick",
			"Jerry Hausner",
			"Peter Capell",
			"Emile Meyer",
			"Bert Freed",
			"Kem Dibbs",
			"Timothy Carey",
			"Fred Bell",
			"John Stein",
			"Harold Benedict",
			"Leon Briggs",
		],
		trailer: "https://www.youtube.com/watch?v=nmDA60X-f_A",
		id: "tt0050825",
		description:
			"A commanding officer defends three scapegoats on trial for a failed offensive that occurred within the French Army in 1916.",
	},
	{
		rank: 62,
		movie_name: "The Shining",
		movie_year: "1980",
		genre: ["Drama", "Horror"],
		director_name: "Stanley Kubrick",
		rating: "8.4",
		actors_list: [
			"Jack Nicholson",
			"Shelley Duvall",
			"Danny Lloyd",
			"Scatman Crothers",
			"Barry Nelson",
			"Philip Stone",
			"Joe Turkel",
			"Anne Jackson",
			"Tony Burton",
			"Lia Beldam",
			"Billie Gibson",
			"Barry Dennen",
			"David Baxt",
			"Manning Redwood",
			"Lisa Burns",
			"Louise Burns",
			"Robin Pappas",
			"Alison Coleridge",
		],
		trailer: "https://www.youtube.com/watch?v=FZQvIJxG9Xs",
		id: "tt0081505",
		description:
			"Jack Torrance accepts a caretaker job at the Overlook Hotel, where he, along with his wife Wendy and their son Danny, must live isolated from the rest of the world for the winter. But they aren't prepared for the madness that lurks within.",
	},
	{
		rank: 63,
		movie_name: "The Great Dictator",
		movie_year: "1940",
		genre: ["Comedy", "Drama", "War"],
		director_name: "Charles Chaplin",
		rating: "8.4",
		actors_list: [
			"Charles Chaplin",
			"Paulette Goddard",
			"Jack Oakie",
			"Reginald Gardiner",
			"Henry Daniell",
			"Billy Gilbert",
			"Grace Hayle",
			"Carter DeHaven",
			"Maurice Moscovitch",
			"Emma Dunn",
			"Bernard Gorcey",
			"Paul Weigel",
			"Chester Conklin",
			"Esther Michelson",
			"Hank Mann",
			"Florence Wright",
			"Eddie Gribbon",
			"Rudolph Anders",
		],
		trailer: "https://www.youtube.com/watch?v=i1C6qZVeFtA",
		id: "tt0032553",
		description:
			"Dictator Adenoid Hynkel tries to expand his empire while a poor Jewish barber tries to avoid persecution from Hynkel's regime.",
	},
	{
		rank: 64,
		movie_name: "Witness for the Prosecution",
		movie_year: "1957",
		genre: ["Crime", "Drama", "Mystery"],
		director_name: "Billy Wilder",
		rating: "8.4",
		actors_list: [
			"Tyrone Power",
			"Marlene Dietrich",
			"Charles Laughton",
			"Elsa Lanchester",
			"John Williams",
			"Henry Daniell",
			"Ian Wolfe",
			"Torin Thatcher",
			"Norma Varden",
			"Una O'Connor",
			"Francis Compton",
			"Philip Tonge",
			"Ruta Lee",
			"Patrick Aherne",
			"Don Ames",
			"Walter Bacon",
			"Eddie Baker",
			"Benjie Bancroft",
		],
		trailer: "https://www.youtube.com/watch?v=GMlJfiA2u7Y",
		id: "tt0051201",
		description:
			"When Leonard Vole is arrested for the sensational murder of a rich, middle-aged widow, the famous Sir Wilfrid Robarts agrees to appear on his behalf. Sir Wilfrid, recovering from a near-fatal heart attack, is supposed to be on a diet of bland, civil suits—but the lure of the criminal courts is too much for him, especially when the case is so difficult.",
	},
	{
		rank: 65,
		movie_name: "Avengers: Infinity War",
		movie_year: "2018",
		genre: ["Action", "Adventure", "Sci-Fi"],
		director_name: "Anthony Russo",
		rating: "8.4",
		actors_list: [
			"Robert Downey Jr.",
			"Chris Hemsworth",
			"Mark Ruffalo",
			"Chris Evans",
			"Scarlett Johansson",
			"Don Cheadle",
			"Benedict Cumberbatch",
			"Tom Holland",
			"Chadwick Boseman",
			"Zoe Saldana",
			"Karen Gillan",
			"Tom Hiddleston",
			"Paul Bettany",
			"Elizabeth Olsen",
			"Anthony Mackie",
			"Sebastian Stan",
			"Idris Elba",
			"Danai Gurira",
		],
		trailer: "https://www.youtube.com/watch?v=6ZfuNTqbHE8",
		id: "tt4154756",
		description:
			"As the Avengers and their allies have continued to protect the world from threats too large for any one hero to handle, a new danger has emerged from the cosmic shadows: Thanos. A despot of intergalactic infamy, his goal is to collect all six Infinity Stones, artifacts of unimaginable power, and use them to inflict his twisted will on all of reality. Everything the Avengers have fought for has led up to this moment - the fate of Earth and existence itself has never been more uncertain.",
	},
	{
		rank: 66,
		movie_name: "Aliens",
		movie_year: "1986",
		genre: ["Action", "Adventure", "Sci-Fi"],
		director_name: "James Cameron",
		rating: "8.4",
		actors_list: [
			"Sigourney Weaver",
			"Michael Biehn",
			"Carrie Henn",
			"Paul Reiser",
			"Lance Henriksen",
			"Bill Paxton",
			"William Hope",
			"Jenette Goldstein",
			"Al Matthews",
			"Mark Rolston",
			"Ricco Ross",
			"Colette Hiller",
			"Daniel Kash",
			"Cynthia Dale Scott",
			"Tip Tipping",
			"Trevor Steedman",
			"Paul Maxwell",
			"Valerie Colgan",
		],
		trailer: "https://www.youtube.com/watch?v=oSeQQlaCZgU",
		id: "tt0090605",
		description:
			"When Ripley's lifepod is found by a salvage crew over 50 years later, she finds that terra-formers are on the very planet they found the alien species. When the company sends a family of colonists out to investigate her story—all contact is lost with the planet and colonists. They enlist Ripley and the colonial marines to return and search for answers.",
	},
	{
		rank: 67,
		movie_name: "American Beauty",
		movie_year: "1999",
		genre: ["Drama"],
		director_name: "Sam Mendes",
		rating: "8.4",
		actors_list: [
			"Kevin Spacey",
			"Annette Bening",
			"Thora Birch",
			"Wes Bentley",
			"Mena Suvari",
			"Peter Gallagher",
			"Allison Janney",
			"Chris Cooper",
			"Scott Bakula",
			"Sam Robards",
			"Barry Del Sherman",
			"Ara Celi",
			"John Cho",
			"Fort Atkinson",
			"Sue Casey",
			"Kent Faulcon",
			"Brenda Wehle",
			"Lisa Cloud",
		],
		trailer: "https://www.youtube.com/watch?v=Ly7rq5EsTC8",
		id: "tt0169547",
		description:
			"Lester Burnham, a depressed suburban father in a mid-life crisis, decides to turn his hectic life around after developing an infatuation with his daughter's attractive friend.",
	},
	{
		rank: 68,
		movie_name: "Dr. Strangelove or: How I Learned to Stop Worrying and Love the Bomb",
		movie_year: "1964",
		genre: ["Comedy", "War"],
		director_name: "Stanley Kubrick",
		rating: "8.4",
		actors_list: [
			"Peter Sellers",
			"George C. Scott",
			"Sterling Hayden",
			"Keenan Wynn",
			"Slim Pickens",
			"Peter Bull",
			"James Earl Jones",
			"Tracy Reed",
			"Jack Creley",
			"Frank Berry",
			"Robert O'Neil",
			"Glenn Beck",
			"Roy Stephens",
			"Shane Rimmer",
			"Hal Galili",
			"Paul Tamarin",
			"Laurence Herder",
			"Gordon Tanner",
		],
		trailer: "https://www.youtube.com/watch?v=jPU1AYTxwg4",
		id: "tt0057012",
		description:
			"After the insane General Jack D. Ripper initiates a nuclear strike on the Soviet Union, a war room full of politicians, generals and a Russian diplomat all frantically try to stop the nuclear strike.",
	},
	{
		rank: 69,
		movie_name: "Spider-Man: Into the Spider-Verse",
		movie_year: "2018",
		genre: ["Animation", "Action", "Adventure"],
		director_name: "Bob Persichetti",
		rating: "8.4",
		actors_list: [
			"Shameik Moore",
			"Jake Johnson",
			"Hailee Steinfeld",
			"Mahershala Ali",
			"Brian Tyree Henry",
			"Lily Tomlin",
			"Luna Lauren Velez",
			"Zoë Kravitz",
			"John Mulaney",
			"Kimiko Glenn",
			"Nicolas Cage",
			"Kathryn Hahn",
			"Liev Schreiber",
			"Chris Pine",
			"Natalie Morales",
			"Edwin R. Habacon",
			"Oscar Isaac",
			"Greta Lee",
		],
		trailer: "https://www.youtube.com/watch?v=g4Hbz2jLxvQ&t=2s",
		id: "tt4633694",
		description:
			"Struggling to find his place in the world while juggling school and family, Brooklyn teenager Miles Morales is unexpectedly bitten by a radioactive spider and develops unfathomable powers just like the one and only Spider-Man. While wrestling with the implications of his new abilities, Miles discovers a super collider created by the madman Wilson 'Kingpin' Fisk, causing others from across the Spider-Verse to be inadvertently transported to his dimension.",
	},
	{
		rank: 70,
		movie_name: "The Dark Knight Rises",
		movie_year: "2012",
		genre: ["Action", "Drama"],
		director_name: "Christopher Nolan",
		rating: "8.4",
		actors_list: [
			"Christian Bale",
			"Tom Hardy",
			"Anne Hathaway",
			"Gary Oldman",
			"Joseph Gordon-Levitt",
			"Marion Cotillard",
			"Morgan Freeman",
			"Michael Caine",
			"Matthew Modine",
			"Alon Aboutboul",
			"Ben Mendelsohn",
			"Burn Gorman",
			"Daniel Sunjata",
			"Aidan Gillen",
			"Sam Kennard",
			"Aliash Tepina",
			"Nestor Carbonell",
			"Brett Cullen",
		],
		trailer: "https://www.youtube.com/watch?v=g8evyE9TuYk",
		id: "tt1345836",
		description:
			"Following the death of District Attorney Harvey Dent, Batman assumes responsibility for Dent's crimes to protect the late attorney's reputation and is subsequently hunted by the Gotham City Police Department. Eight years later, Batman encounters the mysterious Selina Kyle and the villainous Bane, a new terrorist leader who overwhelms Gotham's finest. The Dark Knight resurfaces to protect a city that has branded him an enemy.",
	},
	{
		rank: 71,
		movie_name: "Oldboy",
		movie_year: "2003",
		genre: ["Action", "Drama", "Mystery"],
		director_name: "Park Chan-wook",
		rating: "8.4",
		actors_list: [
			"Choi Min-sik",
			"Yoo Ji-tae",
			"Kang Hye-jeong",
			"Kim Byeong-Ok",
			"Dae-han Ji",
			"Dal-su Oh",
			"Seung-shin Lee",
			"Jin-Seo Yoon",
			"Tae-kyung Oh",
			"Yoo Yeon-Seok",
			"Il-han Oo",
			"Young-hee Lee",
			"Young-ae Kim",
			"Mi Mi Lee",
			"Jae-Duk Han",
			"Jung Ae Kwak",
			"San Kim",
			"Chae-soo Jang",
		],
		trailer: "https://www.youtube.com/watch?v=tAaBkFChaRg",
		id: "tt0364569",
		description:
			"With no clue how he came to be imprisoned, drugged and tortured for 15 years, a desperate businessman seeks revenge on his captors.",
	},
	{
		rank: 72,
		movie_name: "Joker",
		movie_year: "2019",
		genre: ["Crime", "Drama", "Thriller"],
		director_name: "Todd Phillips",
		rating: "8.4",
		actors_list: [
			"Joaquin Phoenix",
			"Robert De Niro",
			"Zazie Beetz",
			"Frances Conroy",
			"Brett Cullen",
			"Shea Whigham",
			"Bill Camp",
			"Glenn Fleshler",
			"Leigh Gill",
			"Josh Pais",
			"Rocco Luna",
			"Marc Maron",
			"Sondra James",
			"Murphy Guyer",
			"Douglas Hodge",
			"Dante Pereira-Olson",
			"Carrie Louise Putrello",
			"Sharon Washington",
		],
		trailer: "https://www.youtube.com/watch?v=t433PEQGErc",
		id: "tt7286456",
		description:
			"During the 1980s, a failed stand-up comedian is driven insane and turns to a life of crime and chaos in Gotham City while becoming an infamous psychopathic crime figure.",
	},
	{
		rank: 73,
		movie_name: "Amadeus",
		movie_year: "1984",
		genre: ["Biography", "Drama", "Music"],
		director_name: "Milos Forman",
		rating: "8.4",
		actors_list: [
			"F. Murray Abraham",
			"Tom Hulce",
			"Elizabeth Berridge",
			"Roy Dotrice",
			"Simon Callow",
			"Christine Ebersole",
			"Jeffrey Jones",
			"Charles Kay",
			"Kenneth McMillan",
			"Kenny Baker",
			"Lisbeth Bartlett",
			"Barbara Bryne",
			"Martin Cavina",
			"Roderick Cook",
			"Milan Demjanenko",
			"Peter DiGesu",
			"Richard Frank",
			"Patrick Hines",
		],
		trailer: "https://www.youtube.com/watch?v=_R4fbdzzXok",
		id: "tt0086879",
		description:
			"Wolfgang Amadeus Mozart is a remarkably talented young Viennese composer who unwittingly finds a fierce rival in the disciplined and determined Antonio Salieri. Resenting Mozart for both his hedonistic lifestyle and his undeniable talent, the highly religious Salieri is gradually consumed by his jealousy and becomes obsessed with Mozart's downfall, leading to a devious scheme that has dire consequences for both men.",
	},
	{
		rank: 74,
		movie_name: "Braveheart",
		movie_year: "1995",
		genre: ["Biography", "Drama", "History"],
		director_name: "Mel Gibson",
		rating: "8.4",
		actors_list: [
			"Mel Gibson",
			"Sophie Marceau",
			"Patrick McGoohan",
			"Angus Macfadyen",
			"James Robinson",
			"Sean Lawlor",
			"Sandy Nelson",
			"James Cosmo",
			"Sean McGinley",
			"Alan Tall",
			"Andrew Weir",
			"Gerda Stevenson",
			"Ralph Riach",
			"Mhairi Calvey",
			"Brian Cox",
			"Peter Hanly",
			"Stephen Billington",
			"Barry McGovern",
		],
		trailer: "https://www.youtube.com/watch?v=nMft5QDOHek",
		id: "tt0112573",
		description:
			"Enraged at the slaughter of Murron, his new bride and childhood love, Scottish warrior William Wallace slays a platoon of the local English lord's soldiers. This leads the village to revolt and, eventually, the entire country to rise up against English rule.",
	},
	{
		rank: 75,
		movie_name: "Toy Story",
		movie_year: "1995",
		genre: ["Animation", "Adventure", "Comedy"],
		director_name: "John Lasseter",
		rating: "8.3",
		actors_list: [
			"Tom Hanks",
			"Tim Allen",
			"Don Rickles",
			"Jim Varney",
			"Wallace Shawn",
			"John Ratzenberger",
			"Annie Potts",
			"John Morris",
			"Erik von Detten",
			"Laurie Metcalf",
			"R. Lee Ermey",
			"Sarah Rayne",
			"Penn Jillette",
			"Jack Angel",
			"Spencer Aste",
			"Greg Berg",
			"Lisa Bradley",
			"Kendall Cunningham",
		],
		trailer: "https://www.youtube.com/watch?v=v-PjgYDrg70",
		id: "tt0114709",
		description:
			"Led by Woody, Andy's toys live happily in his room until Andy's birthday brings Buzz Lightyear onto the scene. Afraid of losing his place in Andy's heart, Woody plots against Buzz. But when circumstances separate Buzz and Woody from their owner, the duo eventually learns to put aside their differences.",
	},
	{
		rank: 76,
		movie_name: "Das Boot",
		movie_year: "1981",
		genre: ["Drama", "War"],
		director_name: "Wolfgang Petersen",
		rating: "8.4",
		actors_list: [
			"Jürgen Prochnow",
			"Herbert Grönemeyer",
			"Klaus Wennemann",
			"Hubertus Bengsch",
			"Martin Semmelrogge",
			"Bernd Tauber",
			"Erwin Leder",
			"Martin May",
			"Heinz Hoenig",
			"Uwe Ochsenknecht",
			"Claude-Oliver Rudolph",
			"Jan Fedder",
			"Ralf Richter",
			"Joachim Bernhard",
			"Oliver Stritzel",
			"Konrad Becker",
			"Lutz Schnell",
			"Martin Hemme",
		],
		trailer: "https://www.youtube.com/watch?v=7pzKyeIex2Y",
		id: "tt0082096",
		description:
			"A German submarine hunts allied ships during the Second World War, but it soon becomes the hunted. The crew tries to survive below the surface, while stretching both the boat and themselves to their limits.",
	},
	{
		rank: 77,
		movie_name: "Coco",
		movie_year: "2017",
		genre: ["Animation", "Adventure", "Comedy"],
		director_name: "Lee Unkrich",
		rating: "8.4",
		actors_list: [
			"Anthony Gonzalez",
			"Gael García Bernal",
			"Benjamin Bratt",
			"Alanna Ubach",
			"Renee Victor",
			"Jaime Camil",
			"Alfonso Arau",
			"Herbert Siguenza",
			"Gabriel Iglesias",
			"Lombardo Boyar",
			"Ana Ofelia Murguía",
			"Natalia Cordova-Buckley",
			"Selene Luna",
			"Edward James Olmos",
			"Sofía Espinosa",
			"Carla Medina",
			"Dyana Ortelli",
			"Luis Valdez",
		],
		trailer: "https://www.youtube.com/watch?v=Rvr68u6k5sI",
		id: "tt2380307",
		description:
			"Despite his family’s baffling generations-old ban on music, Miguel dreams of becoming an accomplished musician like his idol, Ernesto de la Cruz. Desperate to prove his talent, Miguel finds himself in the stunning and colorful Land of the Dead following a mysterious chain of events. Along the way, he meets charming trickster Hector, and together, they set off on an extraordinary journey to unlock the real story behind Miguel's family history.",
	},
	{
		rank: 78,
		movie_name: "Inglourious Basterds",
		movie_year: "2009",
		genre: ["Adventure", "Drama", "War"],
		director_name: "Quentin Tarantino",
		rating: "8.3",
		actors_list: [
			"Brad Pitt",
			"Diane Kruger",
			"Eli Roth",
			"Mélanie Laurent",
			"Christoph Waltz",
			"Michael Fassbender",
			"Daniel Brühl",
			"Til Schweiger",
			"Gedeon Burkhard",
			"Jacky Ido",
			"B.J. Novak",
			"Omar Doom",
			"August Diehl",
			"Denis Ménochet",
			"Sylvester Groth",
			"Martin Wuttke",
			"Mike Myers",
			"Julie Dreyfus",
		],
		trailer: "https://www.youtube.com/watch?v=KnrRy6kSFF0",
		id: "tt0361748",
		description:
			"In Nazi-occupied France during World War II, a group of Jewish-American soldiers known as 'The Basterds' are chosen specifically to spread fear throughout the Third Reich by scalping and brutally killing Nazis. The Basterds, lead by Lt. Aldo Raine soon cross paths with a French-Jewish teenage girl who runs a movie theater in Paris which is targeted by the soldiers.",
	},
	{
		rank: 79,
		movie_name: "Princess Mononoke",
		movie_year: "1997",
		genre: ["Animation", "Adventure", "Fantasy"],
		director_name: "Hayao Miyazaki",
		rating: "8.4",
		actors_list: [
			"Yôji Matsuda",
			"Yuriko Ishida",
			"Yûko Tanaka",
			"Billy Crudup",
			"Billy Bob Thornton",
			"Minnie Driver",
			"John DiMaggio",
			"Claire Danes",
			"John DeMita",
			"Jada Pinkett Smith",
			"Gillian Anderson",
			"Keith David",
			"Corey Burton",
			"Tara Strong",
			"Julia Fletcher",
			"Debi Derryberry",
			"Alex Fernandez",
			"Jack Fletcher",
		],
		trailer: "https://www.youtube.com/watch?v=4OiMOHRDs14",
		id: "tt0119698",
		description:
			"Ashitaka, a prince of the disappearing Emishi people, is cursed by a demonized boar god and must journey to the west to find a cure. Along the way, he encounters San, a young human woman fighting to protect the forest, and Lady Eboshi, who is trying to destroy it. Ashitaka must find a way to bring balance to this conflict.",
	},
	{
		rank: 80,
		movie_name: "Avengers: Endgame",
		movie_year: "2019",
		genre: ["Action", "Adventure", "Drama"],
		director_name: "Anthony Russo",
		rating: "8.4",
		actors_list: [
			"Robert Downey Jr.",
			"Chris Evans",
			"Mark Ruffalo",
			"Chris Hemsworth",
			"Scarlett Johansson",
			"Jeremy Renner",
			"Don Cheadle",
			"Paul Rudd",
			"Benedict Cumberbatch",
			"Chadwick Boseman",
			"Brie Larson",
			"Tom Holland",
			"Karen Gillan",
			"Zoe Saldana",
			"Evangeline Lilly",
			"Tessa Thompson",
			"Rene Russo",
			"Elizabeth Olsen",
		],
		trailer: "https://www.youtube.com/watch?v=TcMBFSGVi1c",
		id: "tt4154796",
		description:
			"After the devastating events of Avengers: Infinity War, the universe is in ruins due to the efforts of the Mad Titan, Thanos. With the help of remaining allies, the Avengers must assemble once more in order to undo Thanos' actions and restore order to the universe once and for all, no matter what consequences may be in store.",
	},
	{
		rank: 81,
		movie_name: "Once Upon a Time in America",
		movie_year: "1984",
		genre: ["Crime", "Drama"],
		director_name: "Sergio Leone",
		rating: "8.3",
		actors_list: [
			"Robert De Niro",
			"James Woods",
			"Elizabeth McGovern",
			"Treat Williams",
			"Tuesday Weld",
			"Burt Young",
			"Joe Pesci",
			"Danny Aiello",
			"William Forsythe",
			"James Hayden",
			"Darlanne Fluegel",
			"Larry Rapp",
			"Dutch Miller",
			"Robert Harper",
			"Richard Bright",
			"Gerard Murphy",
			"Amy Ryder",
			"Olga Karlatos",
		],
		trailer: "https://www.youtube.com/watch?v=LcpCRyNo8T8",
		id: "tt0087843",
		description:
			"A former Prohibition-era Jewish gangster returns to the Lower East Side of Manhattan over thirty years later, where he once again must confront the ghosts and regrets of his old life.",
	},
	{
		rank: 82,
		movie_name: "Good Will Hunting",
		movie_year: "1997",
		genre: ["Drama", "Romance"],
		director_name: "Gus Van Sant",
		rating: "8.3",
		actors_list: [
			"Robin Williams",
			"Matt Damon",
			"Ben Affleck",
			"Stellan Skarsgård",
			"John Mighton",
			"Rachel Majorowski",
			"Colleen McCauley",
			"Casey Affleck",
			"Cole Hauser",
			"Matt Mercier",
			"Ralph St. George",
			"Rob Lynds",
			"Dan Washington",
			"Alison Folland",
			"Derrick Bridgeman",
			"Vik Sahay",
			"Shannon Egleson",
			"Rob Lyons",
		],
		trailer: "https://www.youtube.com/watch?v=ReIJ1lbL-Q8",
		id: "tt0119217",
		description:
			"When professors discover that an aimless janitor is also a math genius, a therapist helps the young man confront the demons that are holding him back.",
	},
	{
		rank: 83,
		movie_name: "Toy Story 3",
		movie_year: "2010",
		genre: ["Animation", "Adventure", "Comedy"],
		director_name: "Lee Unkrich",
		rating: "8.3",
		actors_list: [
			"Tom Hanks",
			"Tim Allen",
			"Joan Cusack",
			"Ned Beatty",
			"Don Rickles",
			"Michael Keaton",
			"Wallace Shawn",
			"John Ratzenberger",
			"Estelle Harris",
			"John Morris",
			"Jodi Benson",
			"Emily Ricks Hahn",
			"Laurie Metcalf",
			"Blake Clark",
			"Teddy Newton",
			"Bud Luckey",
			"Bea Miller",
			"Javier Fernández-Peña",
		],
		trailer: "https://www.youtube.com/watch?v=JcpWXaA2qeg",
		id: "tt0435761",
		description:
			"Woody, Buzz, and the rest of Andy's toys haven't been played with in years. With Andy about to go to college, the gang find themselves accidentally left at a nefarious day care center. The toys must band together to escape and return home to Andy.",
	},
	{
		rank: 84,
		movie_name: "Requiem for a Dream",
		movie_year: "2000",
		genre: ["Drama"],
		director_name: "Darren Aronofsky",
		rating: "8.3",
		actors_list: [
			"Ellen Burstyn",
			"Jared Leto",
			"Jennifer Connelly",
			"Marlon Wayans",
			"Christopher McDonald",
			"Louise Lasser",
			"Marcia Jean Kurtz",
			"Janet Sarno",
			"Suzanne Shepherd",
			"Joanne Gordon",
			"Charlotte Aronofsky",
			"Mark Margolis",
			"Michael Kaycheck",
			"Jack O'Connell",
			"Chas Mastin",
			"Ajay Naidu",
			"Sean Gullette",
			"Samia Shoaib",
		],
		trailer: "https://www.youtube.com/watch?v=QBwzN4v1vA0",
		id: "tt0180093",
		description:
			"The hopes and dreams of four ambitious people are shattered when their drug addictions begin spiraling out of control. A look into addiction and how it overcomes the mind and body.",
	},
	{
		rank: 85,
		movie_name: "Kimi No Na Wa.",
		movie_year: "2016",
		genre: ["Animation", "Drama", "Fantasy"],
		director_name: "Makoto Shinkai",
		rating: "8.4",
		actors_list: [
			"Ryûnosuke Kamiki",
			"Mone Kamishiraishi",
			"Ryô Narita",
			"Aoi Yûki",
			"Nobunaga Shimazaki",
			"Kaito Ishikawa",
			"Kanon Tani",
			"Masaki Terasoma",
			"Sayaka Ôhara",
			"Kazuhiko Inoue",
			"Chafûrin",
			"Kana Hanazawa",
			"Yuka Terasaki",
			"Takashi Onozuka",
			"Yôhei Namekawa",
			"Miyu Tsuji",
			"Shin'ya Hamazoe",
			"Kanami Satô",
		],
		trailer: "https://www.youtube.com/watch?v=NooIc3dMncc",
		id: "tt5311514",
		description:
			"High schoolers Mitsuha and Taki are complete strangers living separate lives. But one night, they suddenly switch places. Mitsuha wakes up in Taki’s body, and he in hers. This bizarre occurrence continues to happen randomly, and the two must adjust their lives around each other.",
	},
	{
		rank: 86,
		movie_name: "Singin' in the Rain",
		movie_year: "1952",
		genre: ["Comedy", "Musical", "Romance"],
		director_name: "Stanley Donen",
		rating: "8.3",
		actors_list: [
			"Gene Kelly",
			"Donald O'Connor",
			"Debbie Reynolds",
			"Jean Hagen",
			"Millard Mitchell",
			"Cyd Charisse",
			"Douglas Fowley",
			"Rita Moreno",
			"Dawn Addams",
			"John Albright",
			"Betty Allen",
			"Sue Allen",
			"John Angelo",
			"Marie Ardell",
			"Bette Arlen",
			"David Bair",
			"Jimmy Bates",
			"Mary Bayless",
		],
		trailer: "https://www.youtube.com/watch?v=lSE8sl2-PZg",
		id: "tt0045152",
		description:
			"In 1927 Hollywood, a silent film production company and cast make a difficult transition to sound.",
	},
	{
		rank: 87,
		movie_name: "3 Idiots",
		movie_year: "2009",
		genre: ["Comedy", "Drama"],
		director_name: "Rajkumar Hirani",
		rating: "8.4",
		actors_list: [
			"Aamir Khan",
			"Madhavan",
			"Mona Singh",
			"Sharman Joshi",
			"Kareena Kapoor",
			"Boman Irani",
			"Omi Vaidya",
			"Olivier Lafont",
			"Rahul Kumar",
			"Parikshit Sahni",
			"Farida Dadi",
			"Amardeep Jha",
			"Mukund Bhatt",
			"Chaitali Bose",
			"Jaaved Jaaferi",
			"Jayant Kripalani",
			"Arun Bali",
			"Shoaib Ahmed",
		],
		trailer: "https://www.youtube.com/watch?v=K0eDlFX9GMc",
		id: "tt1187043",
		description: `Rascal. Joker. Dreamer. Genius... You've never met a college student quite like "Rancho." From the moment he arrives at India's most prestigious university, Rancho's outlandish schemes turn the campus upside down—along with the lives of his two newfound best friends. Together, they make life miserable for "Virus," the school’s uptight and heartless dean. But when Rancho catches the eye of the dean's daughter, Virus sets his sights on flunking out the "3 idiots" once and for all.`,
	},
	{
		rank: 88,
		movie_name: "Star Wars: Episode VI - Return of the Jedi",
		movie_year: "1983",
		genre: ["Action", "Adventure", "Fantasy"],
		director_name: "Richard Marquand",
		rating: "8.3",
		actors_list: [
			"Mark Hamill",
			"Harrison Ford",
			"Carrie Fisher",
			"Billy Dee Williams",
			"Anthony Daniels",
			"Peter Mayhew",
			"Sebastian Shaw",
			"Ian McDiarmid",
			"Frank Oz",
			"James Earl Jones",
			"David Prowse",
			"Alec Guinness",
			"Kenny Baker",
			"Michael Pennington",
			"Kenneth Colley",
			"Michael Carter",
			"Denis Lawson",
			"Tim Rose",
		],
		trailer: "https://www.youtube.com/watch?v=7L8p7_SLzvU",
		id: "tt0086190",
		description:
			"Luke Skywalker leads a mission to rescue his friend Han Solo from the clutches of Jabba the Hutt, while the Emperor seeks to destroy the Rebellion once and for all with a second dreaded Death Star.",
	},
	{
		rank: 89,
		movie_name: "2001: A Space Odyssey",
		movie_year: "1968",
		genre: ["Adventure", "Sci-Fi"],
		director_name: "Stanley Kubrick",
		rating: "8.3",
		actors_list: [
			"Keir Dullea",
			"Gary Lockwood",
			"William Sylvester",
			"Daniel Richter",
			"Leonard Rossiter",
			"Margaret Tyzack",
			"Robert Beatty",
			"Sean Sullivan",
			"Douglas Rain",
			"Frank Miller",
			"Bill Weston",
			"Ed Bishop",
			"Glenn Beck",
			"Alan Gifford",
			"Ann Gillis",
			"Edwina Carroll",
			"Penny Brahms",
			"Heather Downham",
		],
		trailer: "https://www.youtube.com/watch?v=oR_e9y-bka0",
		id: "tt0062622",
		description:
			"Humanity finds a mysterious object buried beneath the lunar surface and sets off to find its origins with the help of HAL 9000, the world's most advanced super computer.",
	},
	{
		rank: 90,
		movie_name: "Eternal Sunshine of the Spotless Mind",
		movie_year: "2004",
		genre: ["Drama", "Romance", "Sci-Fi"],
		director_name: "Michel Gondry",
		rating: "8.3",
		actors_list: [
			"Jim Carrey",
			"Kate Winslet",
			"Tom Wilkinson",
			"Gerry Robert Byrne",
			"Elijah Wood",
			"Thomas Jay Ryan",
			"Mark Ruffalo",
			"Jane Adams",
			"David Cross",
			"Kirsten Dunst",
			"Ryan Whitney",
			"Debbon Ayer",
			"Amir Ali Said",
			"Brian Price",
			"Paulie Litt",
			"Josh Flitter",
			"Lola Daehler",
			"Deirdre O'Connell",
		],
		trailer: "https://www.youtube.com/watch?v=07-QBnEkgXU",
		id: "tt0338013",
		description:
			"Joel Barish, heartbroken that his girlfriend underwent a procedure to erase him from her memory, decides to do the same. However, as he watches his memories of her fade away, he realises that he still loves her, and may be too late to correct his mistake.",
	},
	{
		rank: 91,
		movie_name: "Reservoir Dogs",
		movie_year: "1992",
		genre: ["Crime", "Drama", "Thriller"],
		director_name: "Quentin Tarantino",
		rating: "8.3",
		actors_list: [
			"Harvey Keitel",
			"Tim Roth",
			"Michael Madsen",
			"Chris Penn",
			"Steve Buscemi",
			"Lawrence Tierney",
			"Randy Brooks",
			"Kirk Baltz",
			"Edward Bunker",
			"Quentin Tarantino",
			"Rich Turner",
			"David Steen",
			"Tony Cosmo",
			"Stevo Polyi",
			"Michael Sottile",
			"Robert Ruth",
			"Lawrence Bender",
			"Linda Kaye",
		],
		trailer: "https://www.youtube.com/watch?v=vayksn4Y93A",
		id: "tt0105236",
		description:
			"A botched robbery indicates a police informant, and the pressure mounts in the aftermath at a warehouse. Crime begets violence as the survivors -- veteran Mr. White, newcomer Mr. Orange, psychopathic parolee Mr. Blonde, bickering weasel Mr. Pink and Nice Guy Eddie -- unravel.",
	},
	{
		rank: 92,
		movie_name: "Tengoku to Jigoku",
		movie_year: "1963",
		genre: ["Crime", "Drama", "Mystery"],
		director_name: "Akira Kurosawa",
		rating: "8.4",
		actors_list: [
			"Toshirô Mifune",
			"Yutaka Sada",
			"Tatsuya Nakadai",
			"Kyôko Kagawa",
			"Tatsuya Mihashi",
			"Isao Kimura",
			"Kenjirô Ishiyama",
			"Takeshi Katô",
			"Takashi Shimura",
			"Jun Tazaki",
			"Nobuo Nakamura",
			"Yûnosuke Itô",
			"Tsutomu Yamazaki",
			"Minoru Chiaki",
			"Eijirô Tôno",
			"Masao Shimizu",
			"Masahiko Shimazu",
			"Toshio Egi",
		],
		trailer: "https://www.youtube.com/watch?v=LV3z2Ytxu90",
		id: "tt0057565",
		description:
			"A shoe company executive who has mortgaged everything he has becomes a victim of extortion when his chauffeur's son is kidnapped and is conflicted over whether he should pay the ransom.",
	},
	{
		rank: 93,
		movie_name: "Capharnaüm",
		movie_year: "2018",
		genre: ["Drama"],
		director_name: "Nadine Labaki",
		rating: "8.4",
		actors_list: [
			"Zain Al Rafeea",
			"Yordanos Shiferaw",
			"Boluwatife Treasure Bankole",
			"Kawsar Al Haddad",
			"Fadi Yousef",
			"Cedra Izzam",
			"Alaa Chouchnieh",
			"Elias Khoury",
			"Mohammad Al Abdallah",
			"Mohamad Abdellatif",
			"Abdo Abdo",
			"Hampig Abraham",
			"Jamil Ahmad",
			"Mohamad Akkar",
			"Elias Akobegia",
			"Riman Al Rafeea",
			"Legamett Alamou",
			"Majd Nabil Alhalabi",
		],
		trailer: "https://www.youtube.com/watch?v=JBecbs52Fpo",
		id: "tt8267604",
		description:
			"Zain, a 12-year-old boy scrambling to survive on the streets of Beirut, sues his parents for having brought him into such an unjust world, where being a refugee with no documents means that your rights can easily be denied.",
	},
	{
		rank: 94,
		movie_name: "Citizen Kane",
		movie_year: "1941",
		genre: ["Drama", "Mystery"],
		director_name: "Orson Welles",
		rating: "8.3",
		actors_list: [
			"Orson Welles",
			"Joseph Cotten",
			"Dorothy Comingore",
			"Agnes Moorehead",
			"Ruth Warrick",
			"Ray Collins",
			"Erskine Sanford",
			"Everett Sloane",
			"William Alland",
			"Paul Stewart",
			"George Coulouris",
			"Fortunio Bonanova",
			"Gus Schilling",
			"Philip Van Zandt",
			"Georgia Backus",
			"Harry Shannon",
			"Sonny Bupp",
			"Buddy Swan",
		],
		trailer: "https://www.youtube.com/watch?v=8dxh3lwdOFw",
		id: "tt0033467",
		description:
			"Newspaper magnate, Charles Foster Kane is taken from his mother as a boy and made the ward of a rich industrialist. As a result, every well-meaning, tyrannical or self-destructive move he makes for the rest of his life appears in some way to be a reaction to that deeply wounding event.",
	},
	{
		rank: 95,
		movie_name: "Lawrence of Arabia",
		movie_year: "1962",
		genre: ["Adventure", "Biography", "Drama"],
		director_name: "David Lean",
		rating: "8.3",
		actors_list: [
			"Peter O'Toole",
			"Alec Guinness",
			"Anthony Quinn",
			"Jack Hawkins",
			"Omar Sharif",
			"José Ferrer",
			"Anthony Quayle",
			"Claude Rains",
			"Arthur Kennedy",
			"Donald Wolfit",
			"I.S. Johar",
			"Gamil Ratib",
			"Michel Ray",
			"John Dimech",
			"Zia Mohyeddin",
			"Howard Marion-Crawford",
			"Jack Gwillim",
			"Hugh Miller",
		],
		trailer: "https://www.youtube.com/watch?v=vOlRhGEhG7k",
		id: "tt0056172",
		description:
			"Newspaper magnate, Charles Foster Kane is taken from his mother as a boy and made the ward of a rich industrialist. As a result, every well-meaning, tyrannical or self-destructive move he makes for the rest of his life appears in some way to be a reaction to that deeply wounding event.",
	},
	{
		rank: 96,
		movie_name: "Jagten",
		movie_year: "2012",
		genre: ["Drama"],
		director_name: "Thomas Vinterberg",
		rating: "8.3",
		actors_list: [
			"Mads Mikkelsen",
			"Thomas Bo Larsen",
			"Annika Wedderkopp",
			"Lasse Fogelstrøm",
			"Susse Wold",
			"Anne Louise Hassing",
			"Lars Ranthe",
			"Alexandra Rapaport",
			"Sebastian Bull Sarning",
			"Steen Ordell Guldbrand Jensen",
			"Daniel Engstrup",
			"Troels Thorsen",
			"Søren Rønholt",
			"Hana Shuan",
			"Jytte Kvinesdal",
			"Josefine Gråbøl",
			"Bjarne Henriksen",
			"Nicolai Dahl Hamilton",
		],
		trailer: "https://www.youtube.com/watch?v=ieLIOBkMgAQ",
		id: "tt2106476",
		description:
			"A teacher lives a lonely life, all the while struggling over his son’s custody. His life slowly gets better as he finds love and receives good news from his son, but his new luck is about to be brutally shattered by an innocent little lie.",
	},
	{
		rank: 97,
		movie_name: "M",
		movie_year: "1931",
		genre: ["Crime", "Mystery", "Thriller"],
		director_name: "Fritz Lang",
		rating: "8.3",
		actors_list: [
			"Peter Lorre",
			"Ellen Widmann",
			"Inge Landgut",
			"Otto Wernicke",
			"Theodor Loos",
			"Gustaf Gründgens",
			"Friedrich Gnaß",
			"Fritz Odemar",
			"Paul Kemp",
			"Theo Lingen",
			"Rudolf Blümner",
			"Georg John",
			"Franz Stein",
			"Ernst Stahl-Nachbaur",
			"Gerhard Bienert",
			"Karl Platen",
			"Rosa Valetti",
			"Hertha von Walther",
		],
		trailer: "https://www.youtube.com/watch?v=nsVproWjN6c",
		id: "tt0022100",
		description:
			"In this classic German thriller, Hans Beckert, a serial killer who preys on children, becomes the focus of a massive Berlin police manhunt. Beckert's heinous crimes are so repellant and disruptive to city life that he is even targeted by others in the seedy underworld network. With both cops and criminals in pursuit, the murderer soon realizes that people are on his trail, sending him into a tense, panicked attempt to escape justice.",
	},
	{
		rank: 98,
		movie_name: "North by Northwest",
		movie_year: "1959",
		genre: ["Action", "Adventure", "Mystery"],
		director_name: "Alfred Hitchcock",
		rating: "8.3",
		actors_list: [
			"Cary Grant",
			"Eva Marie Saint",
			"James Mason",
			"Jessie Royce Landis",
			"Leo G. Carroll",
			"Josephine Hutchinson",
			"Philip Ober",
			"Martin Landau",
			"Adam Williams",
			"Edward Platt",
			"Robert Ellenstein",
			"Les Tremayne",
			"Philip Coolidge",
			"Patrick McVey",
			"Edward Binns",
			"Ken Lynch",
			"Stanley Adams",
			"John Alban",
		],
		trailer: "https://www.youtube.com/watch?v=ek7T9Gyl_J4",
		id: "tt0053125",
		description: "Advertising man Roger Thornhill is mistaken for a spy, triggering a deadly cross-country chase.",
	},
	{
		rank: 99,
		movie_name: "Vertigo",
		movie_year: "1958",
		genre: ["Mystery", "Romance", "Thriller"],
		director_name: "Alfred Hitchcock",
		rating: "8.3",
		actors_list: [
			"James Stewart",
			"Kim Novak",
			"Barbara Bel Geddes",
			"Tom Helmore",
			"Henry Jones",
			"Raymond Bailey",
			"Ellen Corby",
			"Konstantin Shayne",
			"Lee Patrick",
			"David Ahdar",
			"Isabel Analla",
			"Jack Ano",
			"Margaret Bacon",
			"John Benson",
			"Danny Borzage",
			"Margaret Brayton",
			"Paul Bryar",
			"Boyd Cabeen",
		],
		trailer: "https://www.youtube.com/watch?v=Z5jvQwwHQNY",
		id: "tt0052357",
		description:
			"A retired San Francisco detective suffering from acrophobia investigates the strange activities of an old friend's wife, all the while becoming dangerously obsessed with her.",
	},
	{
		rank: 100,
		movie_name: "Amélie",
		movie_year: "2001",
		genre: ["Comedy", "Romance"],
		director_name: "Jean-Pierre Jeunet",
		rating: "8.3",
		actors_list: [
			"Audrey Tautou",
			"Mathieu Kassovitz",
			"Rufus",
			"Lorella Cravotta",
			"Serge Merlin",
			"Jamel Debbouze",
			"Clotilde Mollet",
			"Claire Maurier",
			"Isabelle Nanty",
			"Dominique Pinon",
			"Artus de Penguern",
			"Yolande Moreau",
			"Urbain Cancelier",
			"Maurice Bénichou",
			"Michel Robin",
			"Andrée Damant",
			"Claude Perron",
			"Armelle",
		],
		trailer: "https://www.youtube.com/watch?v=Py7cDXQae2U",
		id: "tt0211915",
		description:
			"At a tiny Parisian café, the adorable yet painfully shy Amélie accidentally discovers a gift for helping others. Soon Amelie is spending her days as a matchmaker, guardian angel, and all-around do-gooder. But when she bumps into a handsome stranger, will she find the courage to become the star of her very own love story?",
	},
	{
		rank: 101,
		movie_name: "Idi I Smotri",
		movie_year: "1985",
		genre: ["Drama", "Thriller", "War"],
		director_name: "Elem Klimov",
		rating: "8.4",
		actors_list: [
			"Aleksey Kravchenko",
			"Olga Mironova",
			"Liubomiras Laucevicius",
			"Vladas Bagdonas",
			"Jüri Lumiste",
			"Viktors Lorencs",
			"Kazimir Rabetsky",
			"Evgeniy Tilicheev",
			"G. Velts",
			"V. Vasilyev",
			"Aleksandr Berda",
			"Vasiliy Domrachyov",
			"Nina Evdokimova",
			"Igor Gnevashev",
			"Adolf Hitler",
			"Valery Kravchenko",
			"Evgeniy Kryzhanovskiy",
			"N. Lisichenok",
		],
		trailer: "https://www.youtube.com/watch?v=UHaSQU-4wss",
		id: "tt0091251",
		description:
			"The invasion of a village in Byelorussia by German forces sends young Florya into the forest to join the weary Resistance fighters, against his family's wishes. There he meets a girl, Glasha, who accompanies him back to his village. On returning home, Florya finds his family and fellow peasants massacred. His continued survival amidst the brutal debris of war becomes increasingly nightmarish, a battle between despair and hope.",
	},
	{
		rank: 102,
		movie_name: "A Clockwork Orange",
		movie_year: "1971",
		genre: ["Crime", "Sci-Fi"],
		director_name: "Stanley Kubrick",
		rating: "8.3",
		actors_list: [
			"Malcolm McDowell",
			"Patrick Magee",
			"Michael Bates",
			"Warren Clarke",
			"John Clive",
			"Adrienne Corri",
			"Carl Duering",
			"Paul Farrell",
			"Clive Francis",
			"Michael Gover",
			"Miriam Karlin",
			"James Marcus",
			"Aubrey Morris",
			"Godfrey Quigley",
			"Sheila Raynor",
			"Madge Ryan",
			"John Savident",
			"Anthony Sharp",
		],
		trailer: "https://www.youtube.com/watch?v=T54uZPI4Z8A",
		id: "tt0066921",
		description:
			"In a near-future Britain, young Alexander DeLarge and his pals get their kicks beating and raping anyone they please. When not destroying the lives of others, Alex swoons to the music of Beethoven. The state, eager to crack down on juvenile crime, gives an incarcerated Alex the option to undergo an invasive procedure that'll rob him of all personal agency. In a time when conscience is a commodity, can Alex change his tune?",
	},
	{
		rank: 103,
		movie_name: "Full Metal Jacket",
		movie_year: "1987",
		genre: ["Drama", "War"],
		director_name: "Stanley Kubrick",
		rating: "8.3",
		actors_list: [
			"Matthew Modine",
			"R. Lee Ermey",
			"Vincent D'Onofrio",
			"Adam Baldwin",
			"Dorian Harewood",
			"Kevyn Major Howard",
			"Arliss Howard",
			"Ed O'Ross",
			"John Terry",
			"Kieron Jecchinis",
			"Kirk Taylor",
			"Tim Colceri",
			"Jon Stafford",
			"Bruce Boa",
			"Ian Tyler",
			"Sal Lopez",
			"Gary Landon Mills",
			"Papillon Soo",
		],
		trailer: "https://www.youtube.com/watch?v=n2i917l5RFc",
		id: "tt0093058",
		description:
			"A pragmatic U.S. Marine observes the dehumanizing effects the U.S.-Vietnam War has on his fellow recruits from their brutal boot camp training to the bloody street fighting in Hue.",
	},
	{
		rank: 104,
		movie_name: "Double Indemnity",
		movie_year: "1944",
		genre: ["Crime", "Drama", "Film-Noir"],
		director_name: "Billy Wilder",
		rating: "8.3",
		actors_list: [
			"Fred MacMurray",
			"Barbara Stanwyck",
			"Edward G. Robinson",
			"Byron Barr",
			"Porter Hall",
			"Jean Heather",
			"Tom Powers",
			"Richard Gaines",
			"Fortunio Bonanova",
			"John Philliber",
			"Lev Abramov",
			"James Adamson",
			"John Berry",
			"Raymond Chandler",
			"Edmund Cobb",
			"Kernan Cripps",
			"Betty Farrington",
			"Bess Flowers",
		],
		trailer: "https://www.youtube.com/watch?v=yKrrAa2o9Eg",
		id: "tt0036775",
		description:
			"A rich woman and a calculating insurance agent plot to kill her unsuspecting husband after he signs a double indemnity policy. Against a backdrop of distinctly Californian settings, the partners in crime plan the perfect murder to collect the insurance, which pays double if the death is accidental.",
	},
	{
		rank: 105,
		movie_name: "The Apartment",
		movie_year: "1960",
		genre: ["Comedy", "Drama", "Romance"],
		director_name: "Billy Wilder",
		rating: "8.3",
		actors_list: [
			"Jack Lemmon",
			"Shirley MacLaine",
			"Fred MacMurray",
			"Ray Walston",
			"Jack Kruschen",
			"David Lewis",
			"Hope Holiday",
			"Joan Shawlee",
			"Naomi Stevens",
			"Johnny Seven",
			"Joyce Jameson",
			"Willard Waterman",
			"David White",
			"Edie Adams",
			"Dorothy Abbott",
			"Bill Baldwin",
			"Paul Bradley",
			"Benny Burt",
		],
		trailer: "https://www.youtube.com/watch?v=OcslkrBMLGc",
		id: "tt0053604",
		description:
			"Bud Baxter is a minor clerk in a huge New York insurance company, until he discovers a quick way to climb the corporate ladder. He lends out his apartment to the executives as a place to take their mistresses. Although he often has to deal with the aftermath of their visits, one night he's left with a major problem to solve.",
	},
	{
		rank: 106,
		movie_name: "Scarface",
		movie_year: "1983",
		genre: ["Crime", "Drama"],
		director_name: "Brian De Palma",
		rating: "8.3",
		actors_list: [
			"Al Pacino",
			"Michelle Pfeiffer",
			"Steven Bauer",
			"Mary Elizabeth Mastrantonio",
			"Robert Loggia",
			"Miriam Colon",
			"F. Murray Abraham",
			"Paul Shenar",
			"Harris Yulin",
			"Ángel Salazar",
			"Arnaldo Santana",
			"Pepe Serna",
			"Michael P. Moran",
			"Al Israel",
			"Dennis Holahan",
			"Mark Margolis",
			"Michael Alldredge",
			"Ted Beniades",
		],
		trailer: "https://www.youtube.com/watch?v=cv276Wg3e7I",
		id: "tt0086250",
		description:
			"After getting a green card in exchange for assassinating a Cuban government official, Tony Montana stakes a claim on the drug trade in Miami. Viciously murdering anyone who stands in his way, Tony eventually becomes the biggest drug lord in the state, controlling nearly all the cocaine that comes through Miami. But increased pressure from the police, wars with Colombian drug cartels and his own drug-fueled paranoia serve to fuel the flames of his eventual downfall.",
	},
	{
		rank: 107,
		movie_name: "Ikiru",
		movie_year: "1952",
		genre: ["Drama"],
		director_name: "Akira Kurosawa",
		rating: "8.3",
		actors_list: [
			"Takashi Shimura",
			"Nobuo Kaneko",
			"Shin'ichi Himori",
			"Haruo Tanaka",
			"Minoru Chiaki",
			"Miki Odagiri",
			"Bokuzen Hidari",
			"Minosuke Yamada",
			"Kamatari Fujiwara",
			"Makoto Kobori",
			"Nobuo Nakamura",
			"Atsushi Watanabe",
			"Isao Kimura",
			"Masao Shimizu",
			"Yûnosuke Itô",
			"Kumeko Urabe",
			"Eiko Miyoshi",
			"Noriko Honma",
		],
		trailer: "https://www.youtube.com/watch?v=2VeLN3IDjzQ",
		id: "tt0044741",
		description:
			"Kanji Watanabe is a middle-aged man who has worked in the same monotonous bureaucratic position for decades. Learning he has cancer, he starts to look for the meaning of his life.",
	},
	{
		rank: 108,
		movie_name: "The Sting",
		movie_year: "1973",
		genre: ["Comedy", "Crime", "Drama"],
		director_name: "George Roy Hill",
		rating: "8.3",
		actors_list: [
			"Paul Newman",
			"Robert Redford",
			"Robert Shaw",
			"Charles Durning",
			"Ray Walston",
			"Eileen Brennan",
			"Harold Gould",
			"John Heffernan",
			"Dana Elcar",
			"Jack Kehoe",
			"Dimitra Arliss",
			"Robert Earl Jones",
			"James Sloyan",
			"Charles Dierkop",
			"Lee Paul",
			"Sally Kirkland",
			"Avon Long",
			"Arch Johnson",
		],
		trailer: "https://www.youtube.com/watch?v=_nAIb_J9T5M",
		id: "tt0070735",
		description:
			"A novice con man teams up with an acknowledged master to avenge the murder of a mutual friend by pulling off the ultimate big con and swindling a fortune from a big-time mobster.",
	},
	{
		rank: 109,
		movie_name: "To Kill a Mockingbird",
		movie_year: "1962",
		genre: ["Crime", "Drama"],
		director_name: "Robert Mulligan",
		rating: "8.3",
		actors_list: [
			"Gregory Peck",
			"John Megna",
			"Frank Overton",
			"Rosemary Murphy",
			"Ruth White",
			"Brock Peters",
			"Estelle Evans",
			"Paul Fix",
			"Collin Wilcox Paxton",
			"James Anderson",
			"Alice Ghostley",
			"Robert Duvall",
			"William Windom",
			"Crahan Denton",
			"Richard Hale",
			"Mary Badham",
			"Phillip Alford",
			"R.L. Armstrong",
		],
		trailer: "https://www.youtube.com/watch?v=KR7loA_oziY",
		id: "tt0056592",
		description:
			"Scout Finch, 6, and her older brother Jem live in sleepy Maycomb, Alabama, spending much of their time with their friend Dill and spying on their reclusive and mysterious neighbor, Boo Radley. When Atticus, their widowed father and a respected lawyer, defends a black man named Tom Robinson against fabricated rape charges, the trial and tangent events expose the children to evils of racism and stereotyping.",
	},
	{
		rank: 110,
		movie_name: "Taxi Driver",
		movie_year: "1976",
		genre: ["Crime", "Drama"],
		director_name: "Martin Scorsese",
		rating: "8.2",
		actors_list: [
			"Robert De Niro",
			"Jodie Foster",
			"Cybill Shepherd",
			"Albert Brooks",
			"Diahnne Abbott",
			"Frank Adu",
			"Victor Argo",
			"Gino Ardito",
			"Garth Avery",
			"Peter Boyle",
			"Harry Cohn",
			"Copper Cunningham",
			"Brenda Dickson",
			"Harry Fischler",
			"Nat Grant",
			"Leonard Harris",
			"Richard Higgs",
			"Beau Kayser",
		],
		trailer: "https://www.youtube.com/watch?v=T5IligQP7Fo",
		id: "tt0075314",
		description:
			"A mentally unstable Vietnam War veteran works as a night-time taxi driver in New York City where the perceived decadence and sleaze feed his urge for violent action.",
	},
	{
		rank: 111,
		movie_name: "Up",
		movie_year: "2009",
		genre: ["Animation", "Adventure", "Comedy"],
		director_name: "Pete Docter",
		rating: "8.3",
		actors_list: [
			"Edward Asner",
			"Jordan Nagai",
			"John Ratzenberger",
			"Christopher Plummer",
			"Bob Peterson",
			"Delroy Lindo",
			"Jerome Ranft",
			"David Kaye",
			"Elie Docter",
			"Jeremy Leary",
			"Mickie McGowan",
			"Danny Mann",
			"Donald Fullilove",
			"Jess Harnell",
			"Josh Cooley",
			"Pete Docter",
			"Mark Andrews",
			"Bob Bergen",
		],
		trailer: "https://www.youtube.com/watch?v=HWEW_qTLSEE",
		id: "tt1049413",
		description:
			"Carl Fredricksen spent his entire life dreaming of exploring the globe and experiencing life to its fullest. But at age 78, life seems to have passed him by, until a twist of fate (and a persistent 8-year old Wilderness Explorer named Russell) gives him a new lease on life.",
	},
	{
		rank: 112,
		movie_name: "L.A. Confidential",
		movie_year: "1997",
		genre: ["Crime", "Drama", "Mystery"],
		director_name: "Curtis Hanson",
		rating: "8.2",
		actors_list: [
			"Kevin Spacey",
			"Russell Crowe",
			"Guy Pearce",
			"Kim Basinger",
			"James Cromwell",
			"Danny DeVito",
			"David Strathairn",
			"Ron Rifkin",
			"Matt McCoy",
			"Paul Guilfoyle",
			"Paolo Seganti",
			"Elisabeth Granli",
			"Sandra Taylor",
			"Steve Rankin",
			"Graham Beckel",
			"Allan Graf",
			"Precious Chong",
			"Symba",
		],
		trailer: "https://www.youtube.com/watch?v=6sOXrY5yV4g",
		id: "tt0119488",
		description:
			"Three detectives in the corrupt and brutal L.A. police force of the 1950s use differing methods to uncover a conspiracy behind the shotgun slayings of the patrons at an all-night diner.",
	},
	{
		rank: 114,
		movie_name: "Metropolis",
		movie_year: "1927",
		genre: ["Drama", "Sci-Fi"],
		director_name: "Fritz Lang",
		rating: "8.3",
		actors_list: [
			"Brigitte Helm",
			"Alfred Abel",
			"Gustav Fröhlich",
			"Rudolf Klein-Rogge",
			"Fritz Rasp",
			"Theodor Loos",
			"Erwin Biswanger",
			"Heinrich George",
			"Fritz Alberti",
			"Grete Berger",
			"Olly Boeheim",
			"Max Dietze",
			"Ellen Frey",
			"Beatrice Garga",
			"Heinrich Gotho",
			"Dolly Grey",
			"Anny Hintze",
			"Gottfried Huppertz",
		],
		trailer: "https://www.youtube.com/watch?v=gdtZv3XROnc",
		id: "tt0017136",
		description:
			"In a futuristic city sharply divided between the rich and the poor, the son of the city's mastermind meets a prophet who predicts the coming of a savior to mediate their differences.",
	},
	{
		rank: 120,
		movie_name: "Indiana Jones and the Last Crusade",
		movie_year: "1989",
		genre: ["Action", "Adventure"],
		director_name: "Steven Spielberg",
		rating: "8.2",
		actors_list: [
			"Harrison Ford",
			"Sean Connery",
			"Alison Doody",
			"Denholm Elliott",
			"John Rhys-Davies",
			"Julian Glover",
			"River Phoenix",
			"Michael Byrne",
			"Kevork Malikyan",
			"Robert Eddison",
			"Richard Young",
			"Alexei Sayle",
			"Alex Hyde-White",
			"Paul Maxwell",
			"Isla Blair",
			"Vernon Dobtcheff",
			"J.J. Hardy",
			"Bradley Gregg",
		],
		trailer: "https://www.youtube.com/watch?v=DKg36LBVgfg",
		id: "tt0097576",
		description:
			"In 1938, an art collector appeals to eminent archaeologist Dr. Indiana Jones to embark on a search for the Holy Grail. Indy learns that a medieval historian has vanished while searching for it, and the missing man is his own father, Dr. Henry Jones Sr.. He sets out to rescue his father by following clues in the old man's notebook, which his father had mailed to him before he went missing. Indy arrives in Venice, where he enlists the help of a beautiful academic, Dr. Elsa Schneider, along with Marcus Brody and Sallah. Together they must stop the Nazis from recovering the power of eternal life and taking over the world!",
	},
	{
		rank: 130,
		movie_name: "Some Like It Hot",
		movie_year: "1959",
		genre: ["Comedy", "Music", "Romance"],
		director_name: "Billy Wilder",
		rating: "8.2",
		actors_list: [
			"Marilyn Monroe",
			"Tony Curtis",
			"Jack Lemmon",
			"George Raft",
			"Pat O'Brien",
			"Joe E. Brown",
			"Nehemiah Persoff",
			"Joan Shawlee",
			"Billy Gray",
			"George E. Stone",
			"Dave Barry",
			"Mike Mazurki",
			"Harry Wilson",
			"Beverly Wills",
			"Barbara Drew",
			"Edward G. Robinson Jr.",
			"Sam Bagley",
			"Brandon Beach",
		],
		trailer: "https://www.youtube.com/watch?v=97TYs2YXbJw",
		id: "tt0053291",
		description:
			"Two musicians witness a mob hit and struggle to find a way out of the city before they are found by the gangsters. Their only opportunity is to join an all-girl band as they leave on a tour. To make their getaway they must first disguise themselves as women, then keep their identities secret and deal with the problems this brings - such as an attractive bandmate and a very determined suitor.",
	},
	{
		rank: 131,
		movie_name: "All About Eve",
		movie_year: "1950",
		genre: ["Drama"],
		director_name: "Joseph L. Mankiewicz",
		rating: "8.2",
		actors_list: [
			"Bette Davis",
			"Anne Baxter",
			"George Sanders",
			"Celeste Holm",
			"Gary Merrill",
			"Hugh Marlowe",
			"Gregory Ratoff",
			"Barbara Bates",
			"Marilyn Monroe",
			"Thelma Ritter",
			"Walter Hampden",
			"Randy Stuart",
			"Craig Hill",
			"Leland Harris",
			"Barbara White",
			"Eddie Fisher",
			"William Pullen",
			"Claude Stroud",
		],
		trailer: "https://www.youtube.com/watch?v=uRjKPLH2OaQ",
		id: "tt0042192",
		description:
			"From the moment she glimpses her idol at the stage door, Eve Harrington is determined to take the reins of power away from the great actress Margo Channing. Eve maneuvers her way into Margo's Broadway role, becomes a sensation and even causes turmoil in the lives of Margo's director boyfriend, her playwright and his wife. Only the cynical drama critic sees through Eve, admiring her audacity and perfect pattern of deceit.",
	},
	{
		rank: 144,
		movie_name: "Monty Python and the Holy Grail",
		movie_year: "1975",
		genre: ["Adventure", "Comedy", "Fantasy"],
		director_name: "Terry Gilliam",
		rating: "8.2",
		actors_list: [
			"Graham Chapman",
			"John Cleese",
			"Eric Idle",
			"Terry Gilliam",
			"Terry Jones",
			"Michael Palin",
			"Connie Booth",
			"Carol Cleveland",
			"Neil Innes",
			"Bee Duffell",
			"John Young",
			"Rita Davies",
			"Avril Stewart",
			"Sally Kinghorn",
			"Mark Zycon",
			"Elspeth Cameron",
			"Mitsuko Forstater",
			"Sandy Johnson",
		],
		trailer: "https://www.youtube.com/watch?v=urRkGvhXc8w",
		id: "tt0071853",
		description: `King Arthur, accompanied by his squire, recruits his Knights of the Round Table, including Sir Bedevere the Wise, Sir Lancelot the Brave, Sir Robin the Not-Quite-So-Brave-As-Sir-Lancelot and Sir Galahad the Pure. On the way, Arthur battles the Black Knight who, despite having had all his limbs chopped off, insists he can still fight. They reach Camelot, but Arthur decides not to enter, as "it is a silly place".`,
	},
	{
		rank: 146,
		movie_name: "The Treasure of the Sierra Madre",
		movie_year: "1948",
		genre: ["Adventure", "Drama", "Western"],
		director_name: "John Huston",
		rating: "8.2",
		actors_list: [
			"Humphrey Bogart",
			"Walter Huston",
			"Tim Holt",
			"Bruce Bennett",
			"Barton MacLane",
			"Alfonso Bedoya",
			"Arturo Soto Rangel",
			"Manuel Dondé",
			"José Torvay",
			"Margarito Luna",
			"Robert Blake",
			"Guillermo Calles",
			"Roberto Cañedo",
			"Spencer Chan",
			"Jacqueline Dalya",
			"Ralph Dunn",
			"Ernesto Escoto",
			"Pat Flaherty",
		],
		trailer: "https://www.youtube.com/watch?v=XZ8Q9mOYJgE",
		id: "tt0040897",
		description:
			"Fred C. Dobbs and Bob Curtin, both down on their luck in Tampico, Mexico in 1925, meet up with a grizzled prospector named Howard and decide to join with him in search of gold in the wilds of central Mexico. Through enormous difficulties, they eventually succeed in finding gold, but bandits, the elements, and most especially greed threaten to turn their success into disaster.",
	},
	{
		rank: 156,
		movie_name: "Chinatown",
		movie_year: "1974",
		genre: ["Drama", "Mystery", "Thriller"],
		director_name: "Roman Polanski",
		rating: "8.2",
		actors_list: [
			"Jack Nicholson",
			"Faye Dunaway",
			"John Huston",
			"Perry Lopez",
			"John Hillerman",
			"Darrell Zwerling",
			"Diane Ladd",
			"Roy Jenson",
			"Roman Polanski",
			"Richard Bakalyan",
			"Joe Mantell",
			"Bruce Glover",
			"Nandu Hinds",
			"James O'Rear",
			"James Hong",
			"Beulah Quo",
			"Jerry Fujikawa",
			"Belinda Palmer",
		],
		trailer: "https://www.youtube.com/watch?v=T37QkBc4IGY",
		id: "tt0071315",
		description:
			"Private eye Jake Gittes lives off of the murky moral climate of sunbaked, pre-World War II Southern California. Hired by a beautiful socialite to investigate her husband's extra-marital affair, Gittes is swept into a maelstrom of double dealings and deadly deceits, uncovering a web of personal and political scandals that come crashing together.",
	},
	{
		rank: 179,
		movie_name: "The Third Man",
		movie_year: "1949",
		genre: ["Film-Noir", "Mystery", "Thriller"],
		director_name: "Carol Reed",
		rating: "8.1",
		actors_list: [
			"Orson Welles",
			"Joseph Cotten",
			"Alida Valli",
			"Trevor Howard",
			"Paul Hörbiger",
			"Ernst Deutsch",
			"Erich Ponto",
			"Siegfried Breuer",
			"Hedwig Bleibtreu",
			"Bernard Lee",
			"Wilfrid Hyde-White",
			"Nelly Arno",
			"Jack Arrow",
			"Harold Ayer",
			"Harry Belcher",
			"Leo Bieber",
			"Paul Birch",
			"Martin Boddey",
		],
		trailer: "https://www.youtube.com/watch?v=r9yyDEDGlr0",
		id: "tt0041959",
		description: `In postwar Vienna, Austria, Holly Martins, a writer of pulp Westerns, arrives penniless as a guest of his childhood chum Harry Lime, only to learn he has died. Martins develops a conspiracy theory after learning of a "third man" present at the time of Harry's death, running into interference from British officer Major Calloway, and falling head-over-heels for Harry's grief-stricken lover, Anna.`,
	},
];

const getMovieImageUrl = (id) => {
	return `/data/moviePosters/${id}.jpg`;
};
function filterTopMovies(movies) {
	return movies.map((element) => {
		return {
			id: element.id,
			metaScore: element.metacritic?.metascore?.score || "N/A",
			rating: `${parseFloat(element.rating).toFixed(1)}` || "N/A",
			title: element.movie_name || "N/A",
			description: element.description || "No description available",
			img: getMovieImageUrl(element.id),
			releaseYear: element.movie_year || "N/A",
			actors: element.actors_list.slice(0, 3) || [],
			genres: element.genre.map((genre) => genre) || [],
			trailer: element.trailer,
		};
	});
}

export default filterTopMovies(topRatedMovies);
